import utils from 'utils';
import stockService from 'common/services/stockService';

import synInvoicTemplate from './view/modalSynInvoic.html';
import surePrintTemplate from './view/modalSurePrint.html';
import sureSendTemplate from './view/modalSureSend.html';
import sureRedTemplate from './view/modalSureRed.html';
import sureApplyTemplate from './view/modalSureApplyCancelOvatInvoice.html';
import waitMessageTemplate from './view/waitMessage.html';
import otherBatchTemplate from './view/modalBatchRed.html';
import modalUploadList from './view/modalUploadList.html'
import { param } from 'jquery';

class openedInvoiceListCtrl {
  constructor(
    $rootScope,
    $scope,
    $uibModal,
    $filter,
    logger,
    httpRequest,
    $state,
    operationService,
    sweetalert,
    $timeout,
    openedInvoiceService,
    invoiceOpenService,
    exportSettingService,
    initSortService,
    getOvatAmtService,
    Upload
  ) {
    const { orgId } = $rootScope.userInfo.org;
    $scope.pageState = {
      pageInvType: '1',
    };
    $scope.dictData = {};
    const types = [
      'is_red_all',
      'is_download',
      'invoice_status',
      'is_list',
      'send_status',
      'is_print',
      'invoice_source',
      'yes_no_flag',
      'inv_type_noe',
      'is_cancel',
      'out_system',
      'vehicleInvStatus',
      'ovat_tax_rate',
      'inv_type',
      'ovat_invoice_joint',
      'department_no',
      'ovat_ocr_match_status',
      'ovat_image_source',
    ];
    httpRequest.get_dictByTypeArr(types).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value);
      $scope.dictData.is_red_all = [
        {
          enumTypeCode: null,
          enumName: '蓝票',
          enumCode: '0',
        },
        {
          enumTypeCode: null,
          enumName: '红票',
          enumCode: '1',
        },
      ];
      // 没有电子发票种类
      $scope.dictData.inv_type_noe = $scope.dictData.inv_type.slice(0, 2);
      $scope.dictData.vehicleInvStatus = $scope.dictData.invoice_status.slice(
        0,
        3
      );
      $scope.dictData.inv_type =  $scope.dictData.inv_type.filter(el=>{
          return el.enumCode =='51'||el.enumCode=='52'
      })
    });
    //机构树的check配置信息
    $scope.config = {
      check: {
        enable: true, //显示不显示复选框
        chkboxType: { Y: '', N: '' },
        chkStyle: 'checkbox',
      },
    };
    // 获取机构名称
    function get_getUserOrgList() {
      httpRequest.get_getUserOrgList().then((res) => {
        if (res.data.success) {
          $scope.orgList = res.data.value;
          // 机构勾选变化
          $scope.orgIdListArr = [];
          // 重置默认查询全部机构
          $scope.resetOrgIdList = [];
          // 展开节点及全选
          angular.forEach($scope.orgList, function (item, index) {
            item.open = true;
            if (orgId == item.orgId) {
              item.checked = true;
              $scope.orgIdListArr.push(item.orgId);
              $scope.resetOrgIdList.push(item.orgId);
              // 默认当前操作机构
              $scope.selectedOrgList = [item];
            }
          });
          $scope.param.param.orgIdList = $scope.orgIdListArr;
          // 默认全部机构
          //   $scope.selectedOrgList = $scope.orgList;
          // 返回机构名称
          $scope.fliterOrgName = function (id) {
            if (id === null) {
              return id;
            }
            if (res.data.value === null) {
              return id;
            }
            const fliterUkeyNameArr = res.data.value.filter(
              (item) => item.orgId === id
            );
            if (fliterUkeyNameArr.length > 0) {
              return fliterUkeyNameArr[0].orgName;
            }
            return id;
          };
        }
      });
    }
    // get_getUserOrgList();
    // 所选择的机构名称
    $scope.handleOrgChange = function (orgData) {
      $scope.orgIdListArr = [];
      if (orgData.length > 0) {
        angular.forEach(orgData, function (item, index) {
          $scope.orgIdListArr.push(item.orgId);
        });
        $scope.param.param.orgIdList = $scope.orgIdListArr;
      } else {
        $scope.orgIdListArr = [];
        $scope.param.param.orgIdList = $scope.orgIdListArr;
      }
    };
    // 是否全选机构
    $scope.orgIsCheckAll = (orgList) => {
      let orgListArr = [];
      angular.forEach(orgList, (item, index) => {
        orgListArr.push(item.orgId);
      });
      $scope.param.param.orgIdList = orgListArr;
    };
    //获取所属大区 获取地区时两个参数都不传，获取管理城市时事业部和地区两个都要传
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value;
    });
    // 获取主管税局所在省市
    httpRequest
      .get_getAllTaxBureau(localStorage.getItem('id_token'))
      .then((res) => {
        $scope.dictDataProvince = res.data.value;
      });
    // 获取管理城市时 事业部和地区两个都要传
    $scope.$watch('param.param.regionName', function (newVal, oldVal) {
      //重置
      if ($scope.param.param.regionName == '') {
        $scope.belleRegionCityList = [];
        return;
      }
      angular.forEach($scope.dictData.department_no, function (item, index) {
        if (item.enumName === $scope.param.param.departmentNo) {
          $scope.departmentNo = item.enumCode;
        }
      });
      angular.forEach($scope.belleRegionList, function (item, index) {
        if (item.regionName === newVal) {
          $scope.regionNo = item.treeLevelCode;
        }
      });
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      };
      if (params.affiliation == '' || params.regionNo == '') return;
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value;
      });
    });
    function toOutSystemdata(list, idfield, textfield) {
      const result = [];
      for (const a in list) {
        const tempdata = {
          enumTypeCode: null,
          enumName: '',
          enumCode: '',
        };
        tempdata.enumCode = list[a][idfield];
        tempdata.enumName = list[a][textfield];
        result.push(tempdata);
      }
      return result;
    }
    // 对外系统
    httpRequest.post_outSystemList().then((res) => {
      $scope.dictData.out_system = toOutSystemdata(
        res.data.value,
        'busSysId',
        'busSysName'
      );
    });
    /** *
     * html 动态替换
     */
    $scope.templateHtml = function (html, jsonObj) {
      for (const name in jsonObj) {
        html = html.replace(`{{${name}}}`, jsonObj[name]);
      }
      return html;
    };
    $scope.currentOvatAmt = {};
    $scope.$watch('selectedList.length', () => {
      if (!$scope.selectedList.length) {
        $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal;
        $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum;
        $scope.totalAmt = $scope.currentOvatAmt.totalAmt;
        $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt;
        return;
      }
      const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService(
        $scope.selectedList
      );
      $scope.adValoremTotal = adValoremTotal;
      $scope.invoiceNum = $scope.selectedList.length;
      $scope.totalAmt = totalAmt;
      $scope.totalTaxamt = totalTaxamt;
    });
    $scope.exportCollapsed = false;
    $scope.exportSetting = function exportSetting() {
      exportSettingService($scope.exportID, $scope.exportConfig);
    };
    // 导出参数
    $scope.exportParam = {
      isEleInv: 0,
    };
    // $scope.profileType = '6'
    // 初始化
    const aMonth = utils.genPeriodByMonth();
    $scope.param = {
      param: {},
      pageNum: 1,
      pageSize: 10,
    };
    $scope.reset = function () {
      if ($scope.param.param.invSort == 2) {
        $scope.param.param = {
          isEleInv: 1,
          invSort: 2,
          invoiceDateMin: aMonth.start,
          invoiceDateMax: aMonth.end,
          custCodeName: '',
          isRed: '',
          isDownload: '',
          openPeople: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '',
          invType: '',
          billCode: '',
          billBatchNo: '',
          isList: '',
          phone: '',
          email: '',
          isPrint: '',
          invoiceSource: '',
          isOil: '',
        };
      } else if ($scope.param.param.invSort == 3) {
        $scope.param.param = {
          invSort: 3,
          invoiceDateMin: aMonth.start,
          invoiceDateMax: aMonth.end,
          custCodeName: '',
          isRed: '',
          isPrint: '',
          openPeople: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '',
          invType: 12,
          billCode: '',
          billBatchNo: '',
          vehicleNumber: '',
          ukeyCode: '',
          custIdentifyNo: '',
          isCancel: '',
          cancelDateMin: '',
          cancelDateMax: '',
          invoiceSource: '',
          busSysId: '',
        };
      } else if ($scope.param.param.invSort == 4) {
        $scope.param.param = {
          invSort: 4,
          isEleInv: 0,
          invoiceDateMin: aMonth.start,
          invoiceDateMax: aMonth.end,
          custCodeName: '',
          isRed: '',
          isPrint: '',
          openPeople: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '',
          invType: 41,
          billCode: '',
          billBatchNo: '',
          isList: '',
          ukeyCode: '',
          isCancel: '',
          cancelDateMin: '',
          cancelDateMax: '',
          invoiceSource: '',
          busSysId: '',
          isOil: '',
        };
      } else {
        $scope.param.param = {
          invSort: 1,
          isEleInv: 0,
          invoiceDateMin: aMonth.start,
          invoiceDateMax: aMonth.end,
          custCodeName: '',
          isRed: '',
          isPrint: '',
          openPeople: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '',
          invType: '',
          billCode: '',
          billBatchNo: '',
          isList: '',
          ukeyCode: '',
          isCancel: '',
          cancelDateMin: '',
          cancelDateMax: '',
          invoiceSource: '',
          busSysId: '',
          isOil: '',
          joint: '',
          orgIdList: $scope.resetOrgIdList,
        };
      }
      $scope.param.param.orgIdList = $scope.orgIdListArr;
      // 重置默认机构勾选
      get_getUserOrgList();
      $scope.$broadcast('selectedOrgList', $scope.selectedOrgList);
    };
    // $scope.reset();

    // 开票点数据
    $scope.ukeyList = $rootScope.userInfo.sysUkeyList;
    $scope.resData = [];
    $scope.selectedList = [];
    //* ************页面初始化******************

    function getData() {
      httpRequest.post_getInvoiceStatics($scope.param.param).then((res) => {
        $scope.adValoremTotal =
          res.data.value.adValoremTotal.toFixed(2) || '0.00';
        $scope.invoiceNum = res.data.value.invoiceNum || 0;
        $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00';
        $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00';
        $scope.currentOvatAmt = {
          adValoremTotal: $scope.adValoremTotal,
          invoiceNum: $scope.invoiceNum,
          totalAmt: $scope.totalAmt,
          totalTaxamt: $scope.totalTaxamt,
        };
      });
    }

    // 审核状态 waitInvoiceStatus
    $scope.waitInvoiceStatusList = [];
    // 数据来源变化
    $scope.invoiceSourceChange = function invoiceSourceChange() {
      if (
        $scope.param.param.invoiceSource !== 'table' ||
        $scope.param.param.invoiceSource !== 'interface'
      ) {
        $scope.param.param.buySysName = '';
        $scope.param.param.busSysId = '';
      }
    };
    // tab变化
    $scope.isCollapsed = false; // 批量下拉
    let stroageStr = 'openedInvParam';
    let paramObj = {};
    // 查询列表
    function queryList() {
    //   $scope.param = sessionStorage[stroageStr]
    //     ? JSON.parse(sessionStorage[stroageStr])
    //     : $scope.param;
    //   const openLoading =
    //     $scope.param.pageSize >= 100
    //       ? window.layer.msg('正在查询，请耐心等待', {
    //           time: 0,
    //           skin: 'layer-loading-self',
    //           icon: 16,
    //           shade: 0.5,
    //         })
    //       : null;
      utils.loading('正在查询···');
      httpRequest
        .post_getOpenedInvoiceList($scope.param)
        .then((res) => {
          // $timeout(() => {
          //     $('.layer-loading-self').css('opacity', '0')
          //     $('.layer-loading-self').css('opacity', '1')
          //     $('.layer-loading-self').hide()
          //     $('.layer-loading-self').show()
          // })
          $('.layui-layer-shade').css({
            background: 'rgba(0,0,0,0.5)',
            opacity: '1',
          });
          $scope.isOnSubmit = false;
          $scope.resData = res.data.value.list;
          $scope.selectedList = [];
          // 获取后台分页数据 回写分页组件
          $scope.totalItems = res.data.value.total; //
          $scope.param.pageNum = res.data.value.pageNum;
          $scope.maxSize = res.data.value.pageSize;
        })
        .finally(() => {
        //   window.layer.close(openLoading);
        utils.loaded();
        });
      $scope.exportParam = $.extend($scope.exportParam, $scope.param.param);
      getData();
    }
    // 表头排序
    $scope.orderMap = initSortService(stroageStr);
    $scope.selectedHandle = function () {
      $scope.param.orderMap = {};
      if ($scope.orderMap.sortKey)
        $scope.param.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal;
      sessionStorage.setItem(stroageStr, JSON.stringify($scope.param));
      queryList();
    };
    $scope.tabChange = function tabChange(v) {
      $scope.param.pageNum = 1;
      $scope.reset();
      $scope.param.orderMap = {};
      $scope.orderMap = {};
      $scope.param.param.orgIdList = $scope.resetOrgIdList;
      $scope.active = v;
      // isSearch = true
      if (v == 2 && $scope.profileType !== '12') {
        // 电子发票
        stroageStr = 'openedInvParam12';
        paramObj = {
          isEleInv: 1,
          invSort: 2,
          invoiceDateMin: aMonth.start,
          invoiceDateMax: aMonth.end,
          custCodeName: '',
          isRed: '',
          isDownload: '',
          openPeople: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '',
          invType: '',//51
          billCode: '',
          billBatchNo: '',
          isList: '',
          sendStatus: '',
          isPrint: '',
          invoiceSource: '',
        };
        $scope.param.param.isEleInv = 1;
        $scope.param.param.invType = '';//51
        $scope.customizedConfig = {
          version: 1.0,
          queryConfig: [
            {
              // 0
              label: '开票日期',
              selected: true,
              default: true,
            },
            {
              // 1
              label: '购方名称/信用代码',
              selected: true,
              default: true,
            },
            {
              // 2
              label: '发票性质',
              selected: true,
              default: true,
            },
            {
              // 3
              label: '下载标志',
              selected: true,
              default: true,
            },
            {
              // 4
              label: '开票人',
              selected: false,
              default: false,
            },
            {
              // 5
              label: '发票代码',
              selected: false,
              default: false,
            },
            {
              // 6
              label: '发票状态',
              selected: false,
              default: false,
            },
            {
              // 7
              label: '单据编号',
              selected: true,
              default: true,
            },
            {
              // 8
              label: '清单标志',
              selected: false,
              default: false,
            },
            {
              // 10
              label: '交付状态',
              selected: true,
              default: true,
            },
            {
              // 11
              label: '发票号码',
              selected: false,
              default: false,
            },
            {
              // 12
              label: '打印标识',
              selected: true,
              default: true,
            },
            {
              // 13
              label: '数据来源',
              selected: false,
              default: false,
            },
            {
              // 14
              label: '成品油',
              selected: false,
              default: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
            {
              label: '机构名称',
              selected: false,
              default: false,
            },
            {
              label: '事业部',
              selected: false,
              default: false,
            },
            {
              label: '所属大区',
              selected: false,
              default: false,
            },
            {
              label: '管理城市',
              selected: false,
              default: false,
            },
            {
              label: '主管税局所在省市',
              selected: false,
              default: false,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                label: '业务单号',
                selected: true,
                default: true,
            },
          ],
          table: [
            {
              // 11
              label: '单据编号',
              selected: true,
              default: true,
            },
            {
              // 0
              label: '发票代码',
              selected: true,
              default: true,
            },
            {
              // 1
              label: '发票号码',
              selected: true,
              default: true,
            },
            {
              // 2
              label: '发票性质',
              selected: true,
              default: true,
            },
            {
              // 3
              label: '购方名称/信用代码',
              selected: true,
              default: true,
            },
            {
              label: '购方地址电话',
              selected: false,
              default: false,
            },
            {
              label: '购方开户行及账号',
              selected: false,
              default: false,
            },
            {
              // 4
              label: '合计金额/税额',
              selected: true,
              default: true,
            },
            {
              // 5
              label: '价税合计',
              selected: false,
              default: false,
            },
            {
              label: '含税折扣金额',
              selected: false,
              default: false,
            },
            {
              label: '备注',
              selected: false,
              default: false,
            },
            {
              // 6
              label: '下载标志',
              selected: true,
              default: true,
            },
            {
              // 7
              label: '发票状态',
              selected: true,
              default: true,
            },
            {
              // 8
              label: '开票人/日期',
              selected: false,
              default: false,
            },
            {
              // 9
              label: '数据来源',
              selected: false,
              default: false,
            },
            {
              // 10
              label: '关联销售单',
              selected: false,
              default: false,
            },
            {
              // 12
              label: '清单标志',
              selected: false,
              default: false,
            },
            {
              // 13
              label: '主商品名称',
              selected: false,
              default: false,
            },
            {
              // 14
              label: '税率',
              selected: false,
              default: false,
            },
            {
              // 15
              label: '收款人',
              selected: false,
              default: false,
            },
            {
              // 16
              label: '复核人',
              selected: false,
              default: false,
            },
            {
              label: '手机号',
              selected: false,
              default: false,
            },
            {
              label: '邮箱',
              selected: false,
              default: false,
            },
            {
              label: '交付状态',
              selected: false,
              default: false,
            },
            {
              label: '打印标识',
              selected: false,
              default: false,
            },
            {
              label: '签章状态',
              selected: false,
              default: false,
            },
            {
              label: '开票流水号',
              selected: false,
              default: false,
            },
            {
              label: '成品油',
              selected: false,
              default: false,
            },
            {
              label: '销方开户行及账号',
              selected: false,
              default: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
            {
              label: '机构名称',
              selected: false,
              default: false,
            },
            {
              label: '事业部',
              selected: false,
              default: false,
            },
            {
              label: '所属大区',
              selected: false,
              default: false,
            },
            {
              label: '管理城市',
              selected: false,
              default: false,
            },
            {
              label: '主管税局所在省市',
              selected: false,
              default: false,
            },
            {
              label: '发票种类',
              selected: false,
              default: false,
            },
            {
                label: '业务单号',
                selected: true,
                default: true,
            },
          ],
        };
        $scope.profileType = '12';
        $scope.exportConfig = {
          version: 1.242,
          detailInfo: [
            {
              label: '发票代码',
              selected: true,
              defaultWord: true,
            },
            {
              label: '发票号码',
              selected: true,
              defaultWord: true,
            },
            {
              label: '开票日期',
              selected: true,
              defaultWord: true,
            },
            {
              label: '发票状态',
              selected: true,
              defaultWord: true,
            },
            {
              label: '备注',
              selected: true,
              defaultWord: true,
            },
            {
              label: '货物或应税劳务服务名称',
              selected: true,
              defaultWord: true,
            },
            {
              label: '简称',
              selected: true,
              defaultWord: true,
            },
            {
              label: '规格型号',
              selected: true,
              defaultWord: true,
            },
            {
              label: '单位',
              selected: true,
              defaultWord: true,
            },
            {
              label: '数量',
              selected: true,
              defaultWord: true,
            },
            {
              label: '单价',
              selected: true,
              defaultWord: true,
            },
            {
              label: '金额',
              selected: true,
              defaultWord: true,
            },
            {
              label: '税率',
              selected: true,
              defaultWord: true,
            },
            {
              label: '税额',
              selected: true,
              defaultWord: true,
            },
            {
              label: '价税合计',
              selected: false,
              defaultWord: false,
            },
            {
              label: '零税率标识',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方名称',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方信用代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方地址电话',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方开户行及账号',
              selected: false,
              defaultWord: false,
            },
          ],
          mainInfo: [
            {
              // 0
              label: '单据编号',
              selected: true,
              defaultWord: true,
            },
            {
              // 2
              label: '开票流水号',
              selected: true,
              defaultWord: true,
            },
            {
              // 2
              label: '发票性质',
              selected: true,
              defaultWord: true,
            },
            {
              // 3
              label: '发票代码',
              selected: true,
              defaultWord: true,
            },
            {
              // 4
              label: '发票号码',
              selected: true,
              defaultWord: true,
            },
            {
              // 5
              label: '开票日期',
              selected: true,
              defaultWord: true,
            },
            {
              // 6
              label: '购方名称',
              selected: true,
              defaultWord: true,
            },
            {
              // 7
              label: '购方信用代码',
              selected: true,
              defaultWord: true,
            },
            {
              // 8
              label: '购方地址电话',
              selected: true,
              defaultWord: true,
            },
            {
              // 9
              label: '购方开户行及账号',
              selected: true,
              defaultWord: true,
            },
            {
              // 10
              label: '合计金额',
              selected: true,
              defaultWord: true,
            },
            {
              // 11
              label: '合计税额',
              selected: true,
              defaultWord: true,
            },
            {
              // 12
              label: '价税合计',
              selected: true,
              defaultWord: true,
            },
            {
              // 15
              label: '备注',
              selected: false,
              defaultWord: false,
            },
            {
              label: '税率',
              selected: true,
              defaultWord: true,
            },
            {
              // 13
              label: '含税标志',
              selected: false,
              defaultWord: false,
            },
            {
              // 14
              label: '清单标志',
              selected: false,
              defaultWord: false,
            },
            {
              // 16
              label: '收款人',
              selected: false,
              defaultWord: false,
            },
            {
              // 17
              label: '复核人',
              selected: false,
              defaultWord: false,
            },
            {
              label: '开票人',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方名称',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方信用代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方地址电话',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方开户行及账号',
              selected: false,
              defaultWord: false,
            },
            {
              label: '蓝票发票代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '蓝票发票号码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '发票状态',
              selected: false,
              defaultWord: false,
            },
            {
              label: '作废状态',
              selected: false,
              defaultWord: false,
            },
            {
              label: '打印标志',
              selected: false,
              defaultWord: false,
            },
            {
              label: '成品油',
              selected: false,
              defaultWord: false,
            },
            {
              label: 'URL地址',
              selected: false,
              defaultWord: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
          ],
        };
        $scope.exportID = 101;
      } else if (v == 1 && $scope.profileType !== '6') {
        // 专普票
        stroageStr = 'openedInvParam';
        paramObj = {
          invSort: 1,
          isEleInv: 0,
          invoiceDateMin: aMonth.start,
          invoiceDateMax: aMonth.end,
          custCodeName: '',
          isRed: '',
          isPrint: '',
          openPeople: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '',
          invType: '',
          billCode: '',
          billBatchNo: '',
          isList: '',
          ukeyCode: '',
          isCancel: '',
          cancelDateMin: '',
          cancelDateMax: '',
          invoiceSource: '',
          busSysId: '',
        };
        $scope.param.param.isEleInv = 0;
        $scope.param.param.invType = '';
        $scope.profileType = '6';
        $scope.customizedConfig = {
          version: 1.82,
          queryConfig: [
            {
              label: '开票日期',
              selected: true,
              default: true,
            },
            {
              label: '购方名称/信用代码',
              selected: true,
              default: true,
            },
            {
              label: '发票性质',
              selected: false,
              default: false,
            },
            {
              label: '打印标识',
              selected: true,
              default: true,
            },
            {
              label: '开票人',
              selected: false,
              default: false,
            },
            {
              label: '发票代码',
              selected: false,
              default: false,
            },
            {
              label: '发票状态',
              selected: false,
              default: false,
            },
            {
              label: '单据编号',
              selected: false,
              default: false,
            },
            {
              label: '清单标志',
              selected: false,
              default: false,
            },
            {
              label: '开票点',
              selected: false,
              default: false,
            },
            {
              label: '作废状态',
              selected: false,
              default: false,
            },
            {
              label: '申请作废日期',
              selected: false,
              default: false,
            },
            {
              label: '数据来源',
              selected: false,
              default: false,
            },
            {
              label: '发票号码',
              selected: false,
              default: false,
            },
            {
              label: '业务系统',
              selected: false,
              default: false,
            },
            {
              label: '发票种类',
              selected: true,
              default: true,
            },
            {
              label: '成品油',
              selected: false,
              default: false,
            },
            {
              label: '联次发票',
              selected: false,
              default: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
            {
              label: '机构名称',
              selected: false,
              default: false,
            },
            {
              label: '事业部',
              selected: false,
              default: false,
            },
            {
              label: '所属大区',
              selected: false,
              default: false,
            },
            {
              label: '管理城市',
              selected: false,
              default: false,
            },
            {
              label: '主管税局所在省市',
              selected: false,
              default: false,
            },
            {
              label: '匹配结果',
              selected: false,
              default: false,
            },
            {
              label: '影像ID',
              selected: false,
              default: false,
            },
            {
              label: '影像来源',
              selected: false,
              default: false,
            },
            {
                label: '业务单号',
                selected: true,
                default: true,
            },
          ],
          table: [
            {
              // 14
              label: '单据编号',
              selected: true,
              default: true,
            },
            {
              // 0
              label: '发票性质',
              selected: true,
              default: true,
            },
            {
              // 2
              label: '发票代码',
              selected: true,
              default: true,
            },
            {
              // 3
              label: '发票号码',
              selected: true,
              default: true,
            },
            {
              // 4
              label: '购方名称/信用代码',
              selected: true,
              default: true,
            },
            {
              label: '购方地址电话',
              selected: false,
              default: false,
            },
            {
              label: '购方开户行及账号',
              selected: false,
              default: false,
            },
            {
              // 5
              label: '合计金额/税额',
              selected: true,
              default: true,
            },
            {
              // 6
              label: '价税合计',
              selected: false,
              default: false,
            },
            {
              label: '含税折扣金额',
              selected: false,
              default: false,
            },
            {
              label: '备注',
              selected: false,
              default: false,
            },
            {
              // 7
              label: '打印标志',
              selected: false,
              default: false,
            },
            {
              // 8
              label: '发票状态',
              selected: true,
              default: true,
            },
            {
              // 9
              label: '开票人/日期',
              selected: false,
              default: false,
            },
            {
              // 10
              label: '作废状态',
              selected: false,
              default: false,
            },
            {
              // 11
              label: '申请作废日期',
              selected: false,
              default: false,
            },
            {
              // 12
              label: '数据来源',
              selected: false,
              default: false,
            },
            {
              // 13
              label: '关联销售单',
              selected: false,
              default: false,
            },
            {
              // 15
              label: '清单标志',
              selected: false,
              default: false,
            },
            {
              // 16
              label: '开票点',
              selected: false,
              default: false,
            },
            {
              // 17
              label: '主商品名称',
              selected: false,
              default: false,
            },
            {
              // 18
              label: '税率',
              selected: false,
              default: false,
            },
            {
              // 19
              label: '收款人',
              selected: false,
              default: false,
            },
            {
              // 20
              label: '复核人',
              selected: false,
              default: false,
            },
            {
              // 1
              label: '发票种类',
              selected: true,
              default: true,
            },
            {
              // 1
              label: '开票流水号',
              selected: false,
              default: false,
            },
            {
              label: '成品油',
              selected: false,
              default: false,
            },
            {
              label: '联次发票',
              selected: false,
              default: false,
            },
            {
              label: '销方开户行及账号',
              selected: false,
              default: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
            {
              label: '机构名称',
              selected: false,
              default: false,
            },
            {
              label: '事业部',
              selected: false,
              default: false,
            },
            {
              label: '所属大区',
              selected: false,
              default: false,
            },
            {
              label: '管理城市',
              selected: false,
              default: false,
            },
            {
              label: '主管税局所在省市',
              selected: false,
              default: false,
            },
            {
                label: '匹配结果',
                selected: false,
                default: false,
            },
              {
                label: '影像ID',
                selected: false,
                default: false,
              },
              {
                label: '影像来源',
                selected: false,
                default: false,
              },
              {
                label: '业务单号',
                selected: true,
                default: true,
            },
          ],
        };
        $scope.exportConfig = {
          version: 1.24,
          detailInfo: [
            {
              label: '发票代码',
              selected: true,
              defaultWord: true,
            },
            {
              label: '发票号码',
              selected: true,
              defaultWord: true,
            },
            {
              label: '开票日期',
              selected: true,
              defaultWord: true,
            },
            {
              label: '发票类型',
              selected: true,
              defaultWord: true,
            },
            {
              label: '发票状态',
              selected: true,
              defaultWord: true,
            },
            {
              label: '备注',
              selected: true,
              defaultWord: true,
            },
            {
              label: '货物或应税劳务服务名称',
              selected: true,
              defaultWord: true,
            },
            {
              label: '简称',
              selected: true,
              defaultWord: true,
            },
            {
              label: '规格型号',
              selected: true,
              defaultWord: true,
            },
            {
              label: '单位',
              selected: true,
              defaultWord: true,
            },
            {
              label: '数量',
              selected: true,
              defaultWord: true,
            },
            {
              label: '单价',
              selected: true,
              defaultWord: true,
            },
            {
              label: '金额',
              selected: true,
              defaultWord: true,
            },
            {
              label: '税率',
              selected: true,
              defaultWord: true,
            },
            {
              label: '税额',
              selected: true,
              defaultWord: true,
            },
            {
              label: '价税合计',
              selected: false,
              defaultWord: false,
            },
            {
              label: '零税率标识',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方名称',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方信用代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方地址电话',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方开户行及账号',
              selected: false,
              defaultWord: false,
            },
          ],
          mainInfo: [
            {
              // 0
              label: '单据编号',
              selected: true,
              defaultWord: true,
            },
            {
              // 1
              label: '开票流水号',
              selected: true,
              defaultWord: true,
            },
            {
              // 1
              label: '发票类型',
              selected: true,
              defaultWord: true,
            },
            {
              // 2
              label: '发票性质',
              selected: true,
              defaultWord: true,
            },
            {
              // 3
              label: '发票代码',
              selected: true,
              defaultWord: true,
            },
            {
              // 4
              label: '发票号码',
              selected: true,
              defaultWord: true,
            },
            {
              // 5
              label: '开票日期',
              selected: true,
              defaultWord: true,
            },
            {
              // 6
              label: '购方名称',
              selected: true,
              defaultWord: true,
            },
            {
              // 7
              label: '购方信用代码',
              selected: true,
              defaultWord: true,
            },
            {
              // 8
              label: '购方地址电话',
              selected: true,
              defaultWord: true,
            },
            {
              // 9
              label: '购方开户行及账号',
              selected: true,
              defaultWord: true,
            },
            {
              // 10
              label: '合计金额',
              selected: true,
              defaultWord: true,
            },
            {
              // 11
              label: '合计税额',
              selected: true,
              defaultWord: true,
            },
            {
              // 12
              label: '价税合计',
              selected: true,
              defaultWord: true,
            },
            {
              // 15
              label: '备注',
              selected: false,
              defaultWord: false,
            },
            {
              label: '税率',
              selected: true,
              defaultWord: true,
            },
            {
              // 13
              label: '含税标志',
              selected: false,
              defaultWord: false,
            },
            {
              // 14
              label: '清单标志',
              selected: false,
              defaultWord: false,
            },
            {
              // 16
              label: '收款人',
              selected: false,
              defaultWord: false,
            },
            {
              // 17
              label: '复核人',
              selected: false,
              defaultWord: false,
            },
            {
              label: '开票人',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方名称',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方信用代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方地址电话',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方开户行及账号',
              selected: false,
              defaultWord: false,
            },
            {
              label: '蓝票发票代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '蓝票发票号码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '发票状态',
              selected: false,
              defaultWord: false,
            },
            {
              label: '作废状态',
              selected: false,
              defaultWord: false,
            },
            {
              label: '打印标志',
              selected: false,
              defaultWord: false,
            },
            {
              label: '成品油',
              selected: false,
              defaultWord: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
          ],
        };
        $scope.exportID = 100;
      } else if (v == 3 && $scope.profileType !== '30') {
        // 机动车
        stroageStr = 'openedInvParam30';
        paramObj = {
          invSort: 3,
          invoiceDateMin: aMonth.start,
          invoiceDateMax: aMonth.end,
          custCodeName: '',
          isRed: '',
          isPrint: '',
          openPeople: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '',
          invType: 12,
          billCode: '',
          billBatchNo: '',
          vehicleNumber: '',
          ukeyCode: '',
          custIdentifyNo: '',
          isCancel: '',
          cancelDateMin: '',
          cancelDateMax: '',
          invoiceSource: '',
          busSysId: '',
        };
        $scope.param.param.isEleInv = 0;
        $scope.profileType = '30';
        $scope.param.param.invType = 12;

        $scope.customizedConfig = {
          version: 1.24,
          queryConfig: [
            {
              label: '开票日期',
              selected: true,
              default: true,
            },
            {
              label: '购方名称/信用代码',
              selected: true,
              default: true,
            },
            {
              label: '发票性质',
              selected: true,
              default: true,
            },
            {
              label: '打印标识',
              selected: true,
              default: true,
            },
            {
              label: '开票人',
              selected: false,
              default: false,
            },
            {
              label: '发票代码',
              selected: false,
              default: false,
            },
            {
              label: '发票状态',
              selected: false,
              default: false,
            },
            {
              label: '开票点',
              selected: false,
              default: false,
            },
            {
              label: '身份证/机构代码',
              selected: false,
              default: false,
            },
            {
              label: '作废状态',
              selected: false,
              default: false,
            },
            {
              label: '申请作废日期',
              selected: false,
              default: false,
            },
            {
              label: '数据来源',
              selected: false,
              default: false,
            },
            {
              label: '识别代码/车架号码',
              selected: false,
              default: false,
            },
            {
              label: '发票号码',
              selected: false,
              default: false,
            },
            {
              label: '业务系统',
              selected: false,
              default: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
            {
              label: '机构名称',
              selected: false,
              default: false,
            },
            {
              label: '事业部',
              selected: false,
              default: false,
            },
            {
              label: '所属大区',
              selected: false,
              default: false,
            },
            {
              label: '管理城市',
              selected: false,
              default: false,
            },
            {
              label: '主管税局所在省市',
              selected: false,
              default: false,
            },
          ],
          table: [
            {
              // 17
              label: '单据编号',
              selected: true,
              default: true,
            },
            {
              label: '发票性质',
              selected: true,
              default: true,
            },
            {
              label: '发票代码',
              selected: true,
              default: true,
            },
            {
              label: '发票号码',
              selected: true,
              default: true,
            },
            {
              label: '购方名称/信用代码',
              selected: true,
              default: true,
            },
            {
              // 4
              label: '合计金额/税额',
              selected: true,
              default: true,
            },
            {
              // 5
              label: '价税合计',
              selected: false,
              default: false,
            },
            {
              // 6
              label: '打印标志',
              selected: false,
              default: false,
            },
            {
              // 7
              label: '发票状态',
              selected: true,
              default: true,
            },
            {
              // 8
              label: '开票人/日期',
              selected: false,
              default: false,
            },
            {
              // 9
              label: '作废状态',
              selected: false,
              default: false,
            },
            {
              // 10
              label: '申请作废日期',
              selected: false,
              default: false,
            },
            {
              // 11
              label: '数据来源',
              selected: false,
              default: false,
            },
            {
              // 12
              label: '关联销售单',
              selected: false,
              default: false,
            },
            {
              // 13
              label: '车辆类型',
              selected: false,
              default: false,
            },
            {
              // 14
              label: '开票点',
              selected: false,
              default: false,
            },
            {
              // 15
              label: '识别代码/车架号',
              selected: false,
              default: false,
            },
            {
              // 16
              label: '税率',
              selected: false,
              default: false,
            },
            {
              // 17
              label: '开票流水号',
              selected: false,
              default: false,
            },
            {
              label: '销方开户行及账号',
              selected: false,
              default: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
            {
              label: '机构名称',
              selected: false,
              default: false,
            },
            {
              label: '事业部',
              selected: false,
              default: false,
            },
            {
              label: '所属大区',
              selected: false,
              default: false,
            },
            {
              label: '管理城市',
              selected: false,
              default: false,
            },
            {
              label: '主管税局所在省市',
              selected: false,
              default: false,
            },
          ],
        };
        $scope.exportConfig = {
          version: 1.24,
          mainInfo: [
            {
              // 0
              label: '单据编号',
              selected: true,
              defaultWord: true,
            },
            {
              // 2
              label: '开票流水号',
              selected: true,
              defaultWord: true,
            },
            {
              // 2
              label: '发票性质',
              selected: true,
              defaultWord: true,
            },
            {
              // 3
              label: '发票代码',
              selected: true,
              defaultWord: true,
            },
            {
              // 4
              label: '发票号码',
              selected: true,
              defaultWord: true,
            },
            {
              // 5
              label: '开票日期',
              selected: true,
              defaultWord: true,
            },
            {
              // 6
              label: '购方名称',
              selected: true,
              defaultWord: true,
            },
            {
              // 7
              label: '购方信用代码',
              selected: true,
              defaultWord: true,
            },
            {
              // 8
              label: '车辆类型',
              selected: true,
              defaultWord: true,
            },
            {
              // 9
              label: '厂牌型号',
              selected: true,
              defaultWord: true,
            },
            {
              // 10
              label: '产地',
              selected: true,
              defaultWord: true,
            },
            {
              // 11
              label: '车辆识别代号/车架号码',
              selected: true,
              defaultWord: true,
            },
            {
              // 12
              label: '价税合计',
              selected: true,
              defaultWord: true,
            },
            {
              // 13
              label: '增值税税额',
              selected: true,
              defaultWord: true,
            },
            {
              // 14
              label: '不含税价',
              selected: true,
              defaultWord: true,
            },
            {
              // 15
              label: '身份证号码/组织机构代码',
              selected: false,
              defaultWord: false,
            },
            {
              // 16
              label: '合格证号',
              selected: false,
              defaultWord: false,
            },
            {
              // 17
              label: '进口证明书号',
              selected: false,
              defaultWord: false,
            },
            {
              label: '商检单号',
              selected: false,
              defaultWord: false,
            },
            {
              label: '发动机号码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销货单位名称',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方信用代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方电话',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方地址',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方开户银行',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方开户行账号',
              selected: false,
              defaultWord: false,
            },
            {
              label: '增值税税率或征收率',
              selected: false,
              defaultWord: false,
            },
            {
              label: '主管税务机关及代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '完税凭证号',
              selected: false,
              defaultWord: false,
            },
            {
              label: '吨位',
              selected: false,
              defaultWord: false,
            },
            {
              label: '限乘人数',
              selected: false,
              defaultWord: false,
            },
            {
              label: '生产企业名称',
              selected: false,
              defaultWord: false,
            },
            {
              label: '开票人',
              selected: false,
              defaultWord: false,
            },
            {
              label: '备注',
              selected: false,
              defaultWord: false,
            },
            {
              label: '蓝票发票代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '蓝票发票号码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '发票状态',
              selected: false,
              defaultWord: false,
            },
            {
              label: '作废状态',
              selected: false,
              defaultWord: false,
            },
            {
              label: '打印标志',
              selected: false,
              defaultWord: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
          ],
        };
        $scope.exportID = 102;
      } else if (v == 4 && $scope.profileType !== '45') {
        // 卷票
        stroageStr = 'openedInvParam45';
        paramObj = {
          invSort: 4,
          isEleInv: 0,
          invoiceDateMin: aMonth.start,
          invoiceDateMax: aMonth.end,
          custCodeName: '',
          isRed: '',
          isPrint: '',
          openPeople: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '',
          invType: 41,
          billCode: '',
          billBatchNo: '',
          isList: '',
          ukeyCode: '',
          isCancel: '',
          cancelDateMin: '',
          cancelDateMax: '',
          invoiceSource: '',
          busSysId: '',
        };
        $scope.param.param.isEleInv = 0;
        $scope.param.param.invType = 41;
        $scope.profileType = '45';
        $scope.customizedConfig = {
          version: 1.56,
          queryConfig: [
            {
              label: '开票日期',
              selected: true,
              default: true,
            },
            {
              label: '购方名称/信用代码',
              selected: true,
              default: true,
            },
            {
              label: '发票性质',
              selected: false,
              default: false,
            },
            {
              label: '打印标识',
              selected: true,
              default: true,
            },
            {
              label: '开票人',
              selected: false,
              default: false,
            },
            {
              label: '发票代码',
              selected: false,
              default: false,
            },
            {
              label: '发票状态',
              selected: false,
              default: false,
            },
            {
              label: '单据编号',
              selected: false,
              default: false,
            },
            {
              label: '清单标志',
              selected: false,
              default: false,
            },
            {
              label: '开票点',
              selected: false,
              default: false,
            },
            {
              label: '作废状态',
              selected: false,
              default: false,
            },
            {
              label: '申请作废日期',
              selected: false,
              default: false,
            },
            {
              label: '数据来源',
              selected: false,
              default: false,
            },
            {
              label: '发票号码',
              selected: false,
              default: false,
            },
            {
              label: '业务系统',
              selected: false,
              default: false,
            },
            {
              label: '成品油',
              selected: false,
              default: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
            {
              label: '机构名称',
              selected: false,
              default: false,
            },
            {
              label: '事业部',
              selected: false,
              default: false,
            },
            {
              label: '所属大区',
              selected: false,
              default: false,
            },
            {
              label: '管理城市',
              selected: false,
              default: false,
            },
            {
              label: '主管税局所在省市',
              selected: false,
              default: false,
            },
          ],
          table: [
            {
              // 14
              label: '单据编号',
              selected: true,
              default: true,
            },
            {
              // 0
              label: '发票性质',
              selected: true,
              default: true,
            },
            {
              // 2
              label: '发票代码',
              selected: true,
              default: true,
            },
            {
              // 3
              label: '发票号码',
              selected: true,
              default: true,
            },
            {
              // 4
              label: '购方名称/信用代码',
              selected: true,
              default: true,
            },
            {
              label: '购方地址电话',
              selected: false,
              default: false,
            },
            {
              label: '购方开户行及账号',
              selected: false,
              default: false,
            },
            {
              // 5
              label: '合计金额/税额',
              selected: true,
              default: true,
            },
            {
              // 6
              label: '价税合计',
              selected: false,
              default: false,
            },
            {
              label: '含税折扣金额',
              selected: false,
              default: false,
            },
            {
              label: '备注',
              selected: false,
              default: false,
            },
            {
              // 7
              label: '打印标志',
              selected: false,
              default: false,
            },
            {
              // 8
              label: '发票状态',
              selected: true,
              default: true,
            },
            {
              // 9
              label: '开票人/日期',
              selected: false,
              default: false,
            },
            {
              // 10
              label: '作废状态',
              selected: false,
              default: false,
            },
            {
              // 11
              label: '申请作废日期',
              selected: false,
              default: false,
            },
            {
              // 12
              label: '数据来源',
              selected: false,
              default: false,
            },
            {
              // 13
              label: '关联销售单',
              selected: false,
              default: false,
            },
            {
              // 15
              label: '清单标志',
              selected: false,
              default: false,
            },
            {
              // 16
              label: '开票点',
              selected: false,
              default: false,
            },
            {
              // 17
              label: '主商品名称',
              selected: false,
              default: false,
            },
            {
              // 18
              label: '税率',
              selected: false,
              default: false,
            },
            {
              // 19
              label: '收款人',
              selected: false,
              default: false,
            },
            {
              // 20
              label: '复核人',
              selected: false,
              default: false,
            },
            {
              // 21
              label: '开票流水号',
              selected: false,
              default: false,
            },
            {
              label: '成品油',
              selected: false,
              default: false,
            },
            {
              label: '销方开户行及账号',
              selected: false,
              default: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
            {
              label: '机构名称',
              selected: false,
              default: false,
            },
            {
              label: '事业部',
              selected: false,
              default: false,
            },
            {
              label: '所属大区',
              selected: false,
              default: false,
            },
            {
              label: '管理城市',
              selected: false,
              default: false,
            },
            {
              label: '主管税局所在省市',
              selected: false,
              default: false,
            },
          ],
        };
        $scope.exportConfig = {
          version: 1.24,
          detailInfo: [
            {
              label: '发票代码',
              selected: true,
              defaultWord: true,
            },
            {
              label: '发票号码',
              selected: true,
              defaultWord: true,
            },
            {
              label: '开票日期',
              selected: true,
              defaultWord: true,
            },
            {
              label: '发票状态',
              selected: true,
              defaultWord: true,
            },
            {
              label: '备注',
              selected: true,
              defaultWord: true,
            },
            {
              // 0
              label: '项目',
              selected: true,
              defaultWord: true,
            },
            {
              label: '简称',
              selected: true,
              defaultWord: true,
            },
            {
              // 1
              label: '数量',
              selected: true,
              defaultWord: true,
            },
            {
              // 2
              label: '含税单价',
              selected: true,
              defaultWord: true,
            },
            {
              // 3
              label: '含税金额',
              selected: true,
              defaultWord: true,
            },
            {
              // 6
              label: '税率',
              selected: true,
              defaultWord: true,
            },
            {
              label: '价税合计',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方名称',
              selected: false,
              defaultWord: false,
            },
            {
              label: '购方信用代码',
              selected: false,
              defaultWord: false,
            },
          ],
          mainInfo: [
            {
              // 0
              label: '单据编号',
              selected: true,
              defaultWord: true,
            },
            {
              label: '开票流水号',
              selected: true,
              defaultWord: true,
            },
            {
              // 2
              label: '发票性质',
              selected: true,
              defaultWord: true,
            },
            {
              // 3
              label: '发票代码',
              selected: true,
              defaultWord: true,
            },
            {
              // 4
              label: '发票号码',
              selected: true,
              defaultWord: true,
            },
            {
              // 5
              label: '开票日期',
              selected: true,
              defaultWord: true,
            },
            {
              // 6
              label: '购方名称',
              selected: true,
              defaultWord: true,
            },
            {
              // 7
              label: '购方信用代码',
              selected: true,
              defaultWord: true,
            },
            {
              label: '购方地址电话',
              selected: true,
              defaultWord: true,
            },
            {
              label: '购方开户行及账号',
              selected: true,
              defaultWord: true,
            },
            {
              // 10
              label: '合计金额',
              selected: true,
              defaultWord: true,
            },
            {
              // 15
              label: '备注',
              selected: false,
              defaultWord: false,
            },
            {
              // 16
              label: '收款人',
              selected: false,
              defaultWord: false,
            },
            {
              label: '开票人',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方名称',
              selected: false,
              defaultWord: false,
            },
            {
              label: '销方信用代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '蓝票发票代码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '蓝票发票号码',
              selected: false,
              defaultWord: false,
            },
            {
              label: '发票状态',
              selected: false,
              defaultWord: false,
            },
            {
              label: '作废状态',
              selected: false,
              defaultWord: false,
            },
            {
              label: '打印标志',
              selected: false,
              defaultWord: false,
            },
            {
              label: '成品油',
              selected: false,
              defaultWord: false,
            },
            {
              label: '扩展1',
              selected: false,
              default: false,
            },
            {
              label: '扩展2',
              selected: false,
              default: false,
            },
            {
              label: '扩展3',
              selected: false,
              default: false,
            },
          ],
        };
        $scope.exportID = 103;
      }
      httpRequest.get_getUserCustomized($scope.profileType).then((res) => {
        if (res.data.value) {
          let orderMap = JSON.parse(res.data.value).orderMap;
          if (orderMap) {
            $scope.orderMap = orderMap;
          }
        }
        if ($scope.orderMap.sortKey) {
          $scope.param.orderMap[$scope.orderMap.sortKey] =
            $scope.orderMap.sortVal;
        }
        sessionStorage.setItem(stroageStr, JSON.stringify($scope.param));
        queryList();
      });
      $scope.param.param.invSort = `${v}`;
      $scope.pageState.pageInvType = `${v}`;
      $scope.isCollapsed = false;
      $scope.exportParam = $.extend($scope.exportParam, $scope.param.param);
      $scope.batchDropdownConfig = {
        btnText: '批量操作',
        options: [
          {
            text: '批量打印',
            hasPermit: 'print_openedInvoice_z',
            handler() {
              $scope.surePrintBackToInvoiceBatch();
            },
          },
          {
            text: '批量打印清单',
            hasPermit: 'print_openedInvoice_z',
            isHide: $scope.param.param.invSort != '1',
            handler() {
              $scope.printInvListBatch();
            },
          },
          {
            text: '批量申请作废',
            hasPermit: 'apply_cancelOpenedInvoice',
            isHide: $scope.param.param.invSort == '2',
            handler() {
              $scope.applyCancelOvatInvoiceBatch();
            },
          },
          {
            text: '批量作废',
            hasPermit: 'cancel_openedInvoice',
            isHide: $scope.param.param.invSort == '2',
            handler() {
              $scope.cancelOvatInvoiceBatch();
            },
          },
          {
            text: '批量下载',
            hasPermit: 'openedInvoice_download_d',
            // isHide: $scope.param.param.invSort != '2',
            handler() {
              $scope.downloadBackToInvoiceBatch();
            },
          },
          {
            text: '发送发票',
            hasPermit: 'openedInvoice_send',
            isHide: $scope.param.param.invSort != '2',
            handler() {
              $scope.SendInvoiceBatchList();
            },
          },
          {
            text: '红冲',
            hasPermit: 'openedInvoice_addred',
            handler() {
              $scope.redInvoiceBatchList();
            },
          },
          {
            text: '手工回调',
            hasPermit: 'manual_correction',
            isHide: $scope.active != '2',
            handler() {
              $scope.manualCorrection();
            },
          },
          {
            text: '下载影像',
            hasPermit: 'download_image',
            handler() {
                let listLen = $scope.selectedList.length
                let imageList = $scope.selectedList.filter(el=>el.imageKey)
                let imageListLen = imageList.length
                if(imageListLen != listLen) return logger.logError('选择的数据未上传过发票影像，请先上传影像后再下载。')
                let imageKeyList = imageList.map(el=> el.invoiceId).join(',')
                const _url = `${host.etcloudIvatApp}manage/scanInvoice/batchDownloadOvatInvoiceImage?accessToken=${localStorage.getItem('id_token')}`
                utils.post_downLoad({invoiceIdList:imageKeyList}, _url,function tips(){
                    logger.logSuccess(`下载影像成功${imageListLen}条，下载影像失败${listLen-imageListLen}条。注：未上传过发票影像的发票数据会下载影像失败，请先上传影像。`)
                })
            },
          },
        ],
      };
      $scope.uploadImageConfig = {
        btnText: '上传影像',
        options: [
          {
            text: '扫描仪录入',
            hasPermit: 'scanner_entry',
            handler() {
                $scope.uploadFiles(1)
            },
          },
          {
            text: '本地上传',
            hasPermit: 'local_upload',
            handler() {
                $scope.uploadFiles(2)
            },
          },
        ],
      };
    };
    let active = 1;
    if (!operationService.hasPermit('openedInvoice_specil')) {
      active = 2;
      if (!operationService.hasPermit('openedInvoice_eleInvoice')) {
        active = 3;
        if (!operationService.hasPermit('openedInvoice_vehicle')) {
          active = 4;
          if (!operationService.hasPermit('openedInvoice_roll')) {
            active = 0;
          }
        }
      }
    }
    // console.log(operationService.hasPermit)
    // let isSearch = false
    // $scope.$watch('param', () => {
    //     isSearch = false
    // }, true)
    // 字典字段
    // let invoiceSourceText = '["手工申请","数据同步","接口","中间表","导入"]      '
    $scope.$on('$stateChangeStart', (e, toState) => {
      if (toState.name.indexOf('outputManage.billManage.openedInvoice') == -1) {
        // isSearch && sessionStorage.setItem('openedInvParam', JSON.stringify($scope.queryParam))
        sessionStorage.removeItem('openedInvParam');
        sessionStorage.removeItem('openedInvParam12');
        sessionStorage.removeItem('openedInvParam30');
        sessionStorage.removeItem('openedInvParam45');
        sessionStorage.removeItem('activeParam');
      } else {
        sessionStorage.setItem('activeParam', $scope.active);
      }
    });
    $scope.active = sessionStorage.activeParam
      ? +JSON.parse(sessionStorage.activeParam)
      : active;
    // $scope.tabChange($scope.active);

    // 1.-------------------搜索
    $scope.searchlist = function searchlist() {
      sessionStorage.setItem(stroageStr, JSON.stringify($scope.param));
      queryList();
      $scope.exportParam = $.extend($scope.exportParam, $scope.param.param);
    };
    $scope.tableDropdownConfig = [
      {
        label: '详情',
        handler(item) {
          let url = '';
          if (item.invType == 12) {
            url = $state.href(
              'outputManage.billManage.openedInvoice.vehicleDetail',
              {
                invoiceId: item.invoiceId,
              },
              {
                reload: true,
              }
            );
          } else if (item.invType == 41) {
            url = $state.href(
              'outputManage.billManage.openedInvoice.rollDetail',
              {
                invoiceId: item.invoiceId,
              },
              {
                reload: true,
              }
            );
          } else {
            url = $state.href(
              'outputManage.billManage.openedInvoice.detail',
              {
                invoiceId: item.invoiceId,
              },
              {
                reload: true,
              }
            );
          }
          window.open(url, '_blank');
        },
        showWhile() {
          return true;
        },
      },
      {
        label: '打印',
        handler(item) {
          // ①当选择的发票已打印过，则提示“您选择的发票中有已经打印过的，确定要继续打印吗？”
          if (item.isPrint === '1') {
            sweetalert
              .confirm(
                '打印确认',
                '你选择的发票中有已经打印过的，确定要继续打印吗？'
              )
              .then(() => {
                $scope.printBackToInvoice(item);
              });
          } else {
            $scope.printBackToInvoice(item);
          }
        },
        showWhile(item, hasPermit) {
          return hasPermit('print_openedInvoice_z');
        },
      },
      {
        label: '打印清单',
        handler(item) {
          $scope.printInvListArr([item]);
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('print_openedInvoice_z') &&
            item.invType !== '51' && item.invType !== '52' &&
            item.isList === '1'
          );
        },
      },
      {
        label: '申请作废',
        handler(item) {
          $scope.modalSureApplyCancelOvatInvoice([item]);
        },
        showWhile(item, hasPermit) {
          const statusValid =
            item.invType !== '51' && item.invType !== '52' &&
            item.invoiceStatus === '1' &&
            (item.isCancel === '0' || item.isCancel === '4');
          const noValid = item.invType === '0' && item.isOil === '1';
          return (
            hasPermit('apply_cancelOpenedInvoice') && statusValid && !noValid
          );
        },
      },
      {
        label: '作废',
        handler(item) {
          $scope.modalSureCancelOvatInvoice([item]);
        },
        showWhile(item, hasPermit) {
          const statusValid =
            item.invType !== '51' && item.invType !== '52' &&
            item.invoiceStatus === '1' &&
            (item.isCancel === '0' || item.isCancel === '2');
          const noValid = item.invType === '0' && item.isOil === '1';
          return hasPermit('cancel_openedInvoice') && statusValid && !noValid;
        },
      },
      {
        label: '回退',
        handler(item) {
          sweetalert
            .confirm('确认回退', '确定要回退后则撤回作废申请？')
            .then(() => {
              httpRequest
                .post_backCancelInvoice(item.invoiceId, '回退成功')
                .then((res) => {
                  if (res.data.success) {
                    $timeout(() => {
                      queryList();
                    }, 800);
                  }
                });
            });
        },
        showWhile(item, hasPermit) {
          const statusValid =
            item.invType !== '51' && item.invType !== '52' &&
            item.invoiceStatus === '1' &&
            (item.isCancel === '3' || item.isCancel === '2');
          return hasPermit('openedInvoice_backCancelApply') && statusValid;
        },
      },
      {
        label: '下载',
        handler(item) {
          const extendInfo = JSON.parse(item.extendInfo);
          if (extendInfo && extendInfo.pdfUrl) {
            var pdfUrl = extendInfo.pdfUrl;
            if (pdfUrl.indexOf('.ofd') > 0) {
              item.scanCodeDownload = 'ofd';
            }
          }
          const win = window.open(
            `${host.etcloudOvat}openedInvoice/downloadEteInvoiceSingle?invoiceId=${item.invoiceId}&accessToken=${localStorage.id_token}&scanCodeDownload=${item.scanCodeDownload}`
          );
          win.onbeforeunload = function () {
            queryList();
          };
        },
        showWhile(item, hasPermit) {
          return hasPermit('openedInvoice_download_d') && item.isDownload != 2;
        },
      },
      {
        label: '发送发票',
        handler(item) {
          if (item.isDownload == '2') {
            logger.logError('发票生成中，不可进行发送发票，请稍后再试');
            return;
          }
          $scope.SendInvoiceBatchOne(item);
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('openedInvoice_send') &&
            (item.invType === '51' || item.invType === '52') &&
            item.isDownload != 2
          );
        },
      },
      {
        label: '红冲',
        handler(item) {
          if (item.invType == 51) {
            $scope.singeInvoiceOpen(item);
          } else {
            $scope.singeOtherInvoiceOpen(item);
          }
        },
        showWhile(item, hasPermit) {
          // addred_eleInvoice
          // return hasPermit('openedInvoice_addred') && (item.invType === '51') && (item.totalTaxamt >= 0) && (item.invoiceStatus != '3')
          let result = false;
          if (
            item.isRed == '0' &&
            (item.invoiceStatus == '1' || item.invoiceStatus == '4')
          ) {
            // invoiceStatus: 1全额红冲 4部分红冲
            switch (item.invType) {
              case '2': // 普通发票
                result =
                  hasPermit('openedInvoice_addred') && item.redAmount > 0;
                break;
              case '51': // 电子票
                result =
                  hasPermit('openedInvoice_addred') && item.totalTaxamt >= 0 && item.invType != '52';
                break;
              case '12': // 机动车票
                result =
                  hasPermit('openedInvoice_addred') && item.redAmount > 0;
                break;
              case '41': // 卷票
                result =
                  hasPermit('openedInvoice_addred') && item.redAmount > 0;
                break;
            }
          }
          return result;
        },
      },
      {
        label: '下载影像',
        handler(item) {
            if(Object.is(item.imageKey,null)) return logger.logError('未上传过发票影像，请先上传影像后再下载。')
            window.open(
                `${host.etcloudIvatApp}manage/scanInvoice/downloadOvatOcrImage?invoiceId=${item.invoiceId}&accessToken=${localStorage.id_token}`
              );
        },
        showWhile(item, hasPermit) {
          return hasPermit('download_image') && item.imageKey
        },
      },
      {
        label: '上传影像',
        multiple:false,
        maxSize:'50MB',
        type:'file',
        handler(item, files, errorFile) {
            const _that = this
            if (!files.length || errorFile.length) {
                if (errorFile.length) {
                    logger.logError('上传失败,文件大小不得超过50M')
                }
                return
            }
            const formData = new FormData()
            for (let i = 0; i < files.length; i++) {
                formData.append('file', files[i])
            }
            formData.append('invoiceId', item.invoiceId)
            const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest.post_uploadOvatInvoiceImage(formData).then((res) => {
                // 关闭loading
                layer.close(importinglayer)
                if (!res.data.success) {
                    return logger.logError(res.data.message || '上传失败')
                }
                logger.logSuccess(`${_that.label}成功`)
                queryList();
            }, (response) => {
                if (response.status > 0) {
                    // 关闭loading
                    layer.close(importinglayer)
                    logger.logError('上传失败 ')
                }
            })
        },
        showWhile(item, hasPermit) {
          return hasPermit('upload_image') && !item.imageKey
        },
      },
      {
        label: '删除影像',
        handler(item) {
            let _that = this
            if(Object.is(item.imageKey,null)) return logger.logError('未上传过发票影像，请先上传影像后再删除。')
            sweetalert.confirm('删除提醒', '您正在进行影像删除操作，请确认是否删除已上传关联的发票影像文件？').then(() => {
                httpRequest.post_batchDeleteOvatOcrImage([item.invoiceId]).then(res=>{
                    logger.logSuccess(`${_that.label}成功`)
                    queryList();
                })
            }, () => {})
        },
        showWhile(item, hasPermit) {
          return hasPermit('delete_image') && item.imageKey  && !Object.is(item.imageSource,'4')
        },
      },
    ];
    // 状态按钮滑过
    $scope.workflowHover = function workflowHover(row, flag) {
      row.dropdowstatenhover = flag;
    };
    // 开票信息
    // 选中开票行
    $scope.invoice = {};

    // 电子票打印
    function printEleInvoice(list) {
      for (const key in list) {
        if (list[key].isDownload == 2) {
          logger.logTips('暂未生成PDF文件，无法打印，请稍后再试', 'warn');
          return;
        }
      }
      const idArr = [];
      list.forEach((item) => {
        idArr.push(item.invoiceId);
      });
      httpRequest
        .post_getBatchElePrintUrl({
          ovatIdList: idArr,
        })
        .then((res) => {
          const keys = res.data.value;
          $uibModal
            .open({
              templateUrl: 'showPDF.html',
              controller: [
                '$scope',
                '$uibModalInstance',
                'hasPDFReader',
                'keys',
                function ctrl(scope, uibModalInstance, hasPDFReader, keys) {
                  // const idArr = []
                  // list.forEach((item) => {
                  //     idArr.push(item.invoiceId)
                  // })
                  // const idStr = idArr.join(',')
                  // httpRequest.post_getBatchElePrintUrl({
                  //     ovatIdList: idArr
                  // }).then(res => {
                  //     console.log(res.data.value)
                  // })
                  scope.pdfSrc = `${host.etcloudOvat}openedInvoice/batchEleInvoicePrint?storageId=${keys}&accessToken=${localStorage.id_token}`;
                  if (hasPDFReader()) {
                    scope.canShowPDF = true;
                  }
                  scope.cancel = function cancel() {
                    uibModalInstance.close();
                  };
                },
              ],
              openedClass:
                'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail',
              backdrop: 'static',
              resolve: {
                keys() {
                  return keys;
                },
              },
            })
            .result.then(() => {
              $scope.searchlist();
            });
        });
    }
    /**
     * 批量打印
     */
    $scope.surePrintBackToInvoiceBatch = function () {
      // 1. 获取选种的数据排序
      let invoiceList = $scope.selectedList;
      if (invoiceList.length === 0) {
        logger.logError('还未选择数据');
        return;
      }
      if ($scope.param.param.invSort == '2') {
        printEleInvoice(invoiceList);
      } else {
        invoiceList = $filter('orderBy')(invoiceList, 'invoiceNumber');

        // 2. 判断是否同号
        const codeTemp = invoiceList[0].invoiceCode;
        let number = Number(invoiceList[0].invoiceNumber);
        let hasPrint = 0;
        for (let i = 0; i < invoiceList.length; i++) {
          if (
            codeTemp != invoiceList[i].invoiceCode ||
            Number(invoiceList[i].invoiceNumber) != number
          ) {
            // 如果不同号
            // ②　当选择的发票是不同种类发票或发票代码不相同或发票号码不连号，则提示“请选择同种类且同卷连号的发票进行打印。”
            logger.logError('请选择同种类且同卷连号的发票进行打印');
            return;
          }
          // 是否连号
          number++;
          if (invoiceList[i].isPrint == '1') {
            hasPrint++;
          }
        }

        // 3.如果打印 包喊打印提示
        // ①　当选择的发票已打印过，则提示“您选择的发票中有已经打印过的，确定要继续打印吗？”
        if (hasPrint > 0) {
          sweetalert
            .confirm(
              '打印确认',
              '你选择的发票中有已经打印过的，确定要继续打印吗？'
            )
            .then(() => {
              $scope.modalSurePrint(invoiceList, invoiceList.length);
            });
        } else {
          $scope.modalSurePrint(invoiceList, invoiceList.length);
        }
      }
    };
    $scope.invTypeMap = {
      0: '专用发票',
      2: '普通发票',
      41: '卷式发票',
      51: '电子发票',
      12: '机动车发票',
    };
    // 打印列表
    $scope.printBackToInvoiceList = function printBackToInvoiceList(
      invoiceList,
      totalNum
    ) {
      if (
        !invoiceOpenService.checkIsA9(invoiceList[0].ukeyId) &&
        checkSoapBeforeTaxCore()
      )
        return;

      function onProcess(notify) {
        const { index, invoice } = notify;
        const data = {
          // 等等信息
          index,
          invTypeName: $scope.invTypeMap[invoice.invType],
          invoiceCode: invoice.invoiceCode,
          invoiceNumber: invoice.invoiceNumber,
        };
        const html = $scope.templateHtml(String(waitMessageTemplate), data);
        window.layer.msg(html, {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        });
      }
      utils.loading('打印中，请耐心等待');
      openedInvoiceService
        .print(invoiceList)
        .then(
          () => {
            window.layer.alert(
              `已提交打印！共计<span style='color:#f00;'>${totalNum}</span>张发票`,
              {
                icon: 6,
              }
            );
          },
          (error) => {
            const { errormsg, invoice } = error;
            window.layer.alert(
              `<span style='color:#f00;'>打印失败!${errormsg}</span><br>
                    <sapn class='lable'>发票种类:${
                      $scope.invTypeMap[invoice.invType]
                    }</span><br>
                    <span class='lable'>发票代码${invoice.invoiceCode}发票号码${
                invoice.invoiceNumber
              }</span>`,
              {
                icon: 5,
              },
              (index) => {
                window.layer.close(index);
              }
            );
          },
          (notify) => {
            const { index, invoice } = notify;
            const data = {
              // 等等信息
              index,
              invTypeName: $scope.invTypeMap[invoice.invType],
              invoiceCode: invoice.invoiceCode,
              invoiceNumber: invoice.invoiceNumber,
            };
            const html = $scope.templateHtml(String(waitMessageTemplate), data);
            window.layer.msg(html, {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            });
          }
        )
        .finally(() => {
          utils.loaded();
          queryList();
        });
    };

    $scope.printBackToInvoice = function printBackToInvoice(invoice) {
      const invoiceList = [];
      invoiceList.push(invoice);
      if ($scope.param.param.invSort == '2') {
        printEleInvoice(invoiceList);
      } else {
        $scope.modalSurePrint(invoiceList);
      }
    };
    /** *
     * 确认框
     */
    $scope.modalSurePrint = function modalSurePrint(invoiceList) {
      if (invoiceOpenService.chechManageTypeDiff(invoiceList))
        return logger.logError(
          '您选择的发票开票点不是同一个类型的，请重新选择'
        );
      let manageType = '';
      const ukeyList = JSON.parse(localStorage.user_info).sysUkeyList;
      ukeyList.forEach((item) => {
        item.ukeyId == invoiceList[0].ukeyId && (manageType = item.manageType);
      });
      // ③　单次或批量打印发票时，提示当前发票是否与打印机上的发票纸张对应。确认打印则打印
      const invoiceIdList = [];
      invoiceList.forEach((item) => {
        invoiceIdList.push(item.invoiceId);
      });
      const prams = {
        invType: invoiceList[0].invType,
        invoiceCode: invoiceList[0].invoiceCode,
        totalNum: invoiceList.length,
        invoiceNumberBegin: invoiceList[0].invoiceNumber,
        invoiceNumberEnd: invoiceList[invoiceList.length - 1].invoiceNumber,
        dictData: $scope.dictData,
        isList: '0',
        invoiceIdList,
        manageType,
        ukeyId: invoiceList[0].ukeyId,
      };
      $uibModal
        .open({
          template: surePrintTemplate,
          controller: 'modalSurePrint',
          backdrop: 'static',
          windowClass: 'mod-modal mod-modal-lg modal-reimburse-invoice-detail',
          resolve: {
            items1() {
              return prams;
            },
          },
        })
        .result.then(
          () => {
            $scope.printBackToInvoiceList(invoiceList, invoiceList.length);
          },
          () => {}
        );
    };

    // 3.------------------打印清单：打印发票的销货清单。发票有清单时则显示该按钮，没有清单时不显示。清单打印不影响打印标志。
    $scope.printInvListBatch = function printInvListBatch() {
      // 1. 获取选种的数据排序
      const invoiceList = $scope.selectedList;
      if (invoiceList.length == 0) {
        logger.logError('还未选择数据');
        return;
      }
      // 不是清单发票的列表
      const noListinvoice = $filter('filter')(invoiceList, {
        isList: '0',
      });
      if (noListinvoice.length > 0) {
        logger.logError('选择的发票不全是清单发票');
        return;
      }
      // 循环打印清单发票
      $scope.printInvListArr(invoiceList);
    };
    // 打印列表
    $scope.printInvListArr = function printInvListArr(invoiceList) {
      if (invoiceOpenService.chechManageTypeDiff(invoiceList))
        return logger.logError(
          '您选择的发票开票点不是同一个类型的，请重新选择'
        );
      let manageType = '';
      const ukeyList = JSON.parse(localStorage.user_info).sysUkeyList;
      ukeyList.forEach((item) => {
        item.ukeyId == invoiceList[0].ukeyId && (manageType = item.manageType);
      });
      const invoiceIdList = [];
      invoiceList.forEach((item) => {
        invoiceIdList.push(item.invoiceId);
      });
      const prams = {
        isList: '1',
        listLen: invoiceList.length,
        invoiceIdList,
        invType: manageType == '2' ? -1 : invoiceList[0].invType,
        manageType,
        ukeyId: invoiceList[0].ukeyId,
      };
      $uibModal
        .open({
          template: surePrintTemplate,
          controller: 'modalSurePrint',
          backdrop: 'static',
          openedClass: 'mod-modal mod-modal-lg modal-reimburse-invoice-detail',
          resolve: {
            items1() {
              return prams;
            },
          },
        })
        .result.then(() => {
          utils.loading('正在提交打印...');
          openedInvoiceService
            .printList(invoiceList)
            .then(
              () => {},
              (err) => {
                logger.logError(err);
              },
              (notify) => {
                if (notify.success) {
                  logger.logSuccess(notify.msg);
                } else {
                  logger.logError(notify.msg);
                }
              }
            )
            .finally(() => {
              utils.loaded();
              queryList();
            });
        });
    };
    // 4.------------------申请作废：提交作废发票的申请；
    /**
     * 判断是否跨月
     * @param  {array}  invoiceList [发票列表]
     */
    function hasOverMonth(invoiceList) {
      const now = new Date();
      let currentMonth = now.getMonth() + 1;
      if (currentMonth < 10) {
        currentMonth = `0${currentMonth}`;
      }
      currentMonth = `${now.getFullYear()}-${currentMonth}`;
      for (let i = 0; i < invoiceList.length; i++) {
        const invoice = invoiceList[i];
        const invoiceMonth = invoice.invoiceDate.substring(0, 7);
        if (invoice.isOil === '1' && invoice.invType === '0') {
          return '选择的发票中含有成品油专用发票，无法进行作废！';
        }
        if (currentMonth > invoiceMonth) {
          return `发票[${invoice.invoiceCode}, ${invoice.invoiceNumber}]已跨月，不能作废`;
        }
        if (invoice.invoiceStatus === '2') {
          return `发票[${invoice.invoiceCode}, ${invoice.invoiceNumber}]已作废`;
        }
      }
      return '';
    }
    $scope.applyCancelOvatInvoiceBatch = function () {
      // 批量
      const invoiceList = $filter('filter')($scope.resData, {
        selected: true,
      });
      if (invoiceList.length == 0) {
        logger.logError('还未选择数据');
        return;
      }
      $scope.modalSureApplyCancelOvatInvoice(invoiceList); // 批量
    };
    $scope.applyCancelOvatInvoiceList = function applyCancelOvatInvoiceList(
      invoiceList,
      reason
    ) {
      // 批量
      const invoice = invoiceList[0];
      httpRequest
        .post_applyCancelOvatInvoice({
          invoiceId: invoice.invoiceId,
          cancelReason: reason,
        })
        .then(
          () => {
            logger.logSuccess(`申请作废成功[${invoice.invoiceNumber}]`);
            if (invoiceList.length > 1) {
              $scope.applyCancelOvatInvoiceList(invoiceList.slice(1), reason);
            } else {
              $timeout(() => {
                queryList(); // 刷新页面
              }, 1000);
            }
          },
          (err) => {
            // 错误不阻塞
            logger.logError(`申请作废失败[${invoice.invoiceNumber}]${err}`);
            if (invoiceList.length > 1) {
              $scope.applyCancelOvatInvoiceList(invoiceList.slice(1), reason);
            } else {
              $timeout(() => {
                queryList();
              }, 800); // 刷新页面
            }
          }
        );
    };

    /** *
     * 作废申请确认框
     */
    $scope.modalSureApplyCancelOvatInvoice = function (invoiceList) {
      const msg = hasOverMonth(invoiceList);
      if (msg) {
        logger.logError(msg);
        return;
      }
      const prams = {
        invoiceList,
        isCancel: true,
      };
      const modalInstance = $uibModal.open({
        template: sureApplyTemplate,
        controller: 'modalSurePrint',
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-md',
        resolve: {
          items1() {
            return prams;
          },
        },
      });
      modalInstance.result.then(
        (reason) => {
          $scope.applyCancelOvatInvoiceList(invoiceList, reason.reason);
        },
        () => {}
      );
    };
    // 5.----------------- 作废：作废该张发票；该按钮是否显示判断如上图。
    $scope.cancelOvatInvoiceBatch = function () {
      // 批量
      const invoiceList = $scope.selectedList;
      if (invoiceList.length === 0) {
        logger.logError('还未选择数据');
        return;
      }
      $scope.modalSureCancelOvatInvoice(invoiceList);
    };
    $scope.cancelOvatInvoice = function (invoice) {
      // 单个
      const invoiceList = [];
      invoiceList.push(invoice);
      $scope.modalSureCancelOvatInvoice(invoiceList);
    };

    /** *
     * 作废确认框
     */
    $scope.modalSureCancelOvatInvoice = function (invoiceList) {
      const msg = hasOverMonth(invoiceList);
      if (msg) {
        logger.logError(msg);
        return;
      }
      const prams = {
        invoiceList,
      };
      const modalInstance = $uibModal.open({
        template: sureApplyTemplate,
        controller: 'modalSurePrint',
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-md',
        resolve: {
          items1() {
            return prams;
          },
        },
      });
      modalInstance.result.then(
        () => {
          $scope.cancelOvatInvoiceList(invoiceList);
        },
        () => {}
      );
    };

    $scope.cancelOvatInvoiceList = function cancelOvatInvoiceList(invoiceList) {
      // 批量
      function onProcess(msg) {
        logger.logSuccess(msg);
      }
      utils.loading('作废中请稍候...');
      openedInvoiceService
        .cancelInvoiceList(invoiceList, onProcess)
        .then(
          (successList) => {
            // 只有无key会返回 成功列表 successList
            if (!successList) {
              return;
            } else if (successList.length === 1) {
              logger.logSuccess(`作废成功[${successList[0].invoiceNumber}]`);
            } else if (successList.length === 0) {
              logger.logError('作废失败');
            } else {
              logger.logSuccess(
                `操作完成，共作废成功${successList.length}张发票`
              );
            }
          },
          (err) => {
            logger.logError(err);
          },
          (notify) => {
            logger.logSuccess(notify);
          }
        )
        .finally(() => {
          $timeout(() => {
            utils.loaded();
            $timeout(() => {
              queryList();
            }, 800);
          });
        });
    };

    // 7.------------------电子发票下载
    $scope.downloadBackToInvoiceBatch = function () {
      // 1. 获取选种的数据排序
      const invoiceList = $scope.selectedList;
      if (invoiceList.length == 0) {
        logger.logError('还未选择数据');
        return;
      }
      const existDownload2 = invoiceList.some((x) => x.isDownload == '2');
      if (existDownload2) {
        logger.logTips(
          '发票正处于签章排队中暂时无法进行下载，请稍后再试',
          'warn'
        );
        return;
      }
      let invoiceIds = invoiceList[0].invoiceId;
      for (let i = 1; i < invoiceList.length; i++) {
        invoiceIds = `${invoiceIds},${invoiceList[i].invoiceId}`;
      }
      utils.post_downLoad(
        {
          invoiceIds,
        },
        `${
          host.etcloudOvat
        }openedInvoice/downloadEteInvoice?accessToken=${localStorage.getItem(
          'id_token'
        )}`,
        queryList
      );
      // const url = `${host.etcloudOvat}openedInvoice/downloadEteInvoice?invoiceIds=${invoiceIds}&accessToken=${localStorage.getItem('id_token')}`
      // const win = window.open(url)
      // win.onbeforeunload = function () {
      //     queryList()
      // }
    };
    // 电子发票单个发送
    let prams = {};
    $scope.SendInvoiceBatchOne = function (item) {
      prams = {
        phone: item.custMobile,
        custEmail: item.custEmail,
        phoneShow: 0,
        sendList: [item.invoiceId],
      };
      $scope.SendInvoiceBatch(prams);
    };
    // 批量
    $scope.SendInvoiceBatchList = function () {
      const invoiceList = $scope.selectedList;
      if (invoiceList.length == 0) {
        logger.logError('还未选择数据');
        return;
      }
      const existDownload2 = invoiceList.some((x) => x.isDownload == '2');
      if (existDownload2) {
        logger.logTips(
          '发票正处于签章排队中，暂时无法进行发票交付，请稍后再试',
          'warn'
        );
        return;
      }
      if (invoiceList.length == 1) {
        $scope.SendInvoiceBatchOne(invoiceList[0]);
        return;
      }
      const sendList = [];
      let { custEmail } = invoiceList[0];
      let { custMobile } = invoiceList[0];
      for (let i = 0; i < invoiceList.length; i++) {
        sendList[i] = invoiceList[i].invoiceId;
        if (invoiceList[i].custEmail && invoiceList[i].custEmail != custEmail) {
          custEmail = '';
        }
        if (
          invoiceList[i].custMobile &&
          invoiceList[i].custMobile != custMobile
        ) {
          custMobile = '';
        }
      }
      prams = {
        phone: custMobile,
        custEmail,
        phoneShow: invoiceList.length,
        sendList,
      };
      $scope.SendInvoiceBatch(prams);
    };
    // 发送邮件
    $scope.SendInvoiceBatch = function (prams) {
      $uibModal
        .open({
          template: sureSendTemplate,
          controller: 'modalSureSend',
          backdrop: 'static',
          openedClass: ' mod-modal-RedSend mod-modal mod-modal-md',
          resolve: {
            items1() {
              return prams;
            },
          },
        })
        .result.then((prams) => {
          // 发送短信及邮件 post_batchSendInvoice
          httpRequest
            .post_batchSendInvoice(prams)
            .then((res) => {
              if (res.data.success) {
                logger.logSuccess('发送成功');
              } else {
                logger.error('发送失败');
              }
            })
            .finally(() => {
              $timeout(() => {
                queryList();
              }, 800);
            });
        });
    };

    /** *************************普票、电子票、机动车票、卷票红冲或者批量红冲************************ */
    // 电子票单个红冲确认
    $scope.singeInvoiceOpen = function (item) {
      prams = {
        RedShow: 1, // 标志位 redShow存在表示单个红冲 否则批量红冲，需求后面改为批量红冲与普票确认框保持一致
        invoiceCode: item.invoiceCode,
        invoiceNumber: item.invoiceNumber,
        adValoremTotal: item.adValoremTotal,
        invoiceIds: item.invoiceId,
        billCode: item.billCode,
        diskCode: item.diskCode,
        saleCreditCode: item.saleCreditCode,
      };
      $scope.openEleRedConfirm(prams);
    };
    // 卷票、机动车票、普票 单个红冲
    $scope.singeOtherInvoiceOpen = function (item) {
      if (item.invType == 12) {
        $state.go('outputManage.billManage.openedInvoice.redInfoVehicle', {
          invType: '12',
          parentInvoiceId: item.invoiceId,
        });
      } else if (item.invType == 41) {
        $state.go('outputManage.billManage.openedInvoice.redInfoRoll', {
          invType: '41',
          parentInvoiceId: item.invoiceId,
        });
      } else if (item.invType == 2) {
        $state.go('outputManage.billManage.openedInvoice.redInfoInv', {
          invType: '2',
          parentInvoiceId: item.invoiceId,
        });
      }
    };
    // 批量红冲验证
    $scope.batchValidate = function (selectedList) {
      const selectedListLen = selectedList.length;
      if (selectedListLen == 0) {
        logger.logError('还未选择数据');
        return false;
      }
      const diskCode = selectedList[0].diskCode;
      for (let i = 0; i < selectedListLen; i++) {
        if (selectedList[i].diskCode != diskCode) {
          logger.logError('请选择同一开票机号的票据');
          return false;
        }
      }
      switch ($scope.param.param.invSort.toString()) {
        case '2': // 电子票
          for (let i = 0; i < selectedListLen; i++) {
            if (
              selectedList[i].isRed == '1' ||
              selectedList[i].invoiceStatus == '3'
            ) {
              logger.logError('请选择发票性质为“蓝票”并且未开红冲的票据');
              return false;
            }
          }
          break;
        case '1': // 普通发票
          const hasSpecial = selectedList.some((a) => a.invType == '0');
          const hasNormal = selectedList.some((a) => a.invType == '2');
          if (hasSpecial && hasNormal) {
            logger.logError('您选择的发票种类不是同一票种，请重新选择；');
            return false;
          }
          if (hasSpecial) {
            logger.logError(
              '您选择的发票种类为：专用发票，请通过在红字信息表进行红字发票申请；'
            );
            return false;
          }
        case '3': // 机动车票
        case '4': // 卷票
          for (let i = 0; i < selectedListLen; i++) {
            if (selectedList[i].isRed == '1') {
              logger.logError('您选择的发票含有红票，不能红冲，请重新选择！');
              return false;
            }
            if (selectedList[i].invoiceStatus == 2) {
              logger.logError('您选择的发票存在已作废发票，请重新选择！');
              return false;
            }
          }
          break;
      }
      return true;
    };
    // 批量手工回调 临时添加的功能
    $scope.manualCorrection = ()=> {
        if (!$scope.selectedList.length) {
            return logger.logError('请至少选择一条单据');
          }
          let idList = []
          $scope.selectedList.forEach((el)=>{
              idList.push(el.invoiceId)
          })
          httpRequest.post_submitOpenInvCallbackBelleNew(idList,'批量手工回调成功').then(res=>{
            queryList();
          })
    }
    // 批量红冲按钮
    $scope.redInvoiceBatchList = function () {
      let prams1 = [];
      const invoiceList = $scope.selectedList;
      const hasinvType52 = invoiceList.some((el) => el.invType == '52');
      if(hasinvType52) return logger.logError('电子专用发票不能直接红冲，请核对勾选数据。')
      if ($scope.batchValidate(invoiceList)) {
        invoiceList.forEach((invoice) => {
          const obj = {
            invoiceCode: invoice.invoiceCode,
            invoiceNumber: invoice.invoiceNumber,
            adValoremTotal: invoice.adValoremTotal,
            invoiceId: invoice.invoiceId,
            billCode: invoice.billCode,
            totalTaxamt: invoice.totalTaxamt,
            totalAmt: invoice.totalAmt,
            redAmount: invoice.redAmount,
            diskCode: invoice.diskCode,
            saleCreditCode: invoice.saleCreditCode,
            invType: invoice.invType,
          };
          prams1.push(obj);
        });

        const hasValue0 = invoiceList.some((b) => b.redAmount == 0);
        if (hasValue0) {
          sweetalert
            .confirm(
              '红冲确认',
              '您选择的发票存在可红冲金额为0发票，是否忽略此发票继续红冲？'
            )
            .then(() => {
              prams1 = invoiceList.filter((c) => c.redAmount > 0);
              if (prams1.length) {
                $scope.openOtherRedConfirm(prams1, invoiceList);
              } else {
                logger.logError('您选择的发票已经全部红冲，请重新选择！');
              }
            });
        } else {
          $scope.openOtherRedConfirm(prams1, invoiceList);
        }
      }
    };
    // 普票、电子票、机动车、卷票红冲确认
    $scope.openOtherRedConfirm = function (selectedInvoices, invoiceList) {
      $uibModal
        .open({
          template: otherBatchTemplate,
          controller: 'modalBatchRed',
          backdrop: 'static',
          openedClass:
            'mod-modal-haslist mod-modal mod-modal-lg mod-modal-batchred',
          resolve: {
            items1() {
              return selectedInvoices;
            },
          },
        })
        .result.then((openParam) => {
          let isVehicle = false;
          // if (!(invoiceOpenService.checkIsAgent(openParam) && openParam.invType == '51') && checkSoapBeforeTaxCore()) {
          //     logger.logError('未检测到对应的开票设备，红冲失败')
          //     return
          // }
          if ($scope.param.param.invSort == '3') {
            isVehicle = true;
          }
          if (openParam.type == 1) {
            // 批量开票打印
            $scope.openOtherBatchRedPrint(
              openParam.invoiceIds,
              isVehicle,
              invoiceList
            );
            console.log('批量红冲开票打印');
          } else {
            // 批量开票
            console.log('批量开票');
            $scope.openOtherBatchRed(openParam.invoiceIds, isVehicle);
          }
        });
    };
    // 电子发票红冲确认 --需求变化为单个红冲保持现状、批量红冲与普票、卷票、机动车保持一致
    $scope.openEleRedConfirm = function (prams1) {
      $uibModal
        .open({
          template: sureRedTemplate,
          controller: 'modalSureRed',
          backdrop: 'static',
          openedClass: 'mod-modal-RedSend mod-modal mod-modal-md ',
          resolve: {
            items1() {
              return prams1;
            },
          },
        })
        .result.then((res) => {
          // 红冲电子票新增
          // if (!invoiceOpenService.checkIsAgent(res) && checkSoapBeforeTaxCore()) {
          //     logger.logError('未检测到对应的开票设备，红冲失败')
          //     return
          // }
          $scope.openSingeRedInvoice([res.invoiceIds]); // 单个红冲
        });
    };
    // 开票检查
    function check(invoiceList, isPrint, isBatchCheck) {
      const userInfo = JSON.parse(localStorage.getItem('user_info'));
      if (userInfo.org.invoiceFlag !== 1) {
        logger.logError('您所在机构禁止开票，请联系管理员启用');
        return false;
      }
      if (
        userInfo.sale.taxplayerType === '3' ||
        userInfo.sale.taxplayerType === '4' ||
        userInfo.sale.taxplayerType === '9'
      ) {
        logger.logError('您所在企业纳税人类型不具备开票资格');
        return false;
      }
      const { invType } = invoiceList[0];
      for (let i = 0; i < invoiceList.length; i++) {
        if (isPrint && invoiceList[i].invType !== invType) {
          logger.logError('开票打印不能选择多种类型的发票');
          return false;
        }
        if (isBatchCheck && invoiceList[i].taxRate === '') {
          logger.logError(
            `发票号码${invoiceList[i].blueInvoiceNumber}票为多税率，请通过单张红冲进行开票`
          );
          return false;
        }
      }
      return true;
    }
    // 普票、卷票、电子票 批量开票方法
    function openBatch(invoiceList, isAgent) {
      function successCallback(errorInvoiceIds) {
        utils.loaded();
        const errorNum = errorInvoiceIds.length;
        const len = invoiceList.length;
        logger.logMsg({
          title: '操作结果',
          icon: 1,
          message: `共计${len}张发票,成功${
            len - errorNum
          }张，失败${errorNum}张！`,
        });
        if (errorNum) {
          httpRequest.post_reddingFailedBackWrite(errorInvoiceIds).then(() => {
            queryList();
          });
        } else {
          queryList();
        }
      }

      function errorCallback() {
        utils.loaded();
      }

      function notifyCallback(currentIndex = 0) {
        const currentInvoice = invoiceList[currentIndex];
        if ($scope.isRoll) {
          utils.loading(`正在开具第${currentIndex + 1}张发票， 发票种类卷票`);
        } else {
          utils.loading(
            `正在开具第${currentIndex + 1}张发票， 发票种类：${
              $scope.invTypeMap[currentInvoice.invType]
            }`
          );
        }
      }
      let API =
        isAgent == 2
          ? 'a9OpenBatch'
          : isAgent == 1
          ? 'agentOpenBatch'
          : 'scanOpenBatch';
      invoiceOpenService[API](invoiceList, true)
        .then(successCallback, errorCallback, notifyCallback)
        .finally(() => {
          utils.loaded();
        });
    }
    // 普票、卷票、电子票 批量开票打印方法
    function openPrintBatch(invoiceList, diskInfo) {
      const len = invoiceList.length;

      function successCallback(errorNum) {
        utils.loaded();
        logger.logMsg({
          title: '操作结果',
          icon: 1,
          message: `共计${len}张发票,成功${
            len - errorNum
          }张，失败${errorNum}张！`,
        });
        queryList();
      }

      function errorCallback(error) {
        utils.loaded();
        logger.logError(error.retmsg);
        httpRequest.post_reddingFailedBackWrite([error.waitId]).then(() => {
          queryList();
        });
        setTimeout(() => {
          logger.logMsg({
            title: '操作结果',
            icon: 1,
            message: `共计${len}张发票,成功${len - error.errorNum}张，失败${
              error.errorNum
            }张！`,
          });
        }, 1500);
      }

      function notifyCallback(currentIndex) {
        const currentInvoice = invoiceList[currentIndex];
        utils.loaded();
        if ($scope.isRoll) {
          utils.loading(`正在开具第${currentIndex + 1}张发票， 发票种类卷票`);
        } else {
          utils.loading(
            `正在开具第${currentIndex + 1}张发票， 发票种类：${
              $scope.invTypeMap[currentInvoice.invType]
            }`
          );
        }
      }
      invoiceOpenService
        .openPrintBatchBackID(invoiceList, diskInfo.taxCode, diskInfo.machinNo)
        .then(successCallback, errorCallback, notifyCallback)
        .finally(() => {
          utils.loaded();
        });
    }
    // 电子票单个红冲--需求保持电子票红冲原样不变
    $scope.openSingeRedInvoice = function (invoiceIds) {
      const errorList = [];
      httpRequest.post_batchReddingInvoice(invoiceIds).then((res) => {
        if (res.data.success && res.data.value) {
          const invoice = res.data.value[0];
          if (invoiceOpenService.checkIsAgent(invoice)) {
            utils.loading('开票中，请耐心等待');
            invoiceOpenService
              .agentOpen(invoice, '1')
              .then(
                () => {
                  logger.logSuccess('红冲成功');
                },
                () => {
                  httpRequest.post_reddingFailedBackWrite([invoice.waitId]);
                }
              )
              .finally(() => {
                utils.loaded();
                queryList();
              });
          } else {
            httpRequest
              .post_lockOvatInvoice({
                invoiceIds,
                isLock: '1',
              })
              .then(() => {
                const invoiceDTOs = res.data.value;
                const result = check(invoiceDTOs);
                if (!result) {
                httpRequest.post_lockOvatInvoice({
                    invoiceIds,
                    isLock: '0',
                    });
                  return;
                }
                utils.loading('开票中，请耐心等待');
                if (invoiceOpenService.checkIsA9(invoiceDTOs[0].ukeyId)) {
                  httpRequest
                    .post_openInvoice({
                      waitId: invoiceDTOs[0].waitId,
                      deleteFlag: true,
                    })
                    .then((res) => {
                      if (res.data.value.code == 0) {
                        logger.logSuccess('红冲成功');
                      } else {
                        logger.logError(res.data.value.msg);
                      }
                    })
                    .finally(() => {
                      utils.loaded();
                      httpRequest.post_lockOvatInvoice({
                        invoiceIds,
                        isLock: '0',
                      });
                      $timeout(() => {
                        queryList();
                      }, 800);
                    });
                } else {    
                  invoiceOpenService
                    .checkDiskAndOpen(invoiceDTOs[0])
                    .then(
                      () => {
                        logger.logSuccess('红冲成功');
                      },
                      (error) => {
                        utils.loaded();
                        logger.logError(error.retmsg || error);
                        errorList.push(invoiceDTOs[0].waitId);
                        httpRequest.post_lockOvatInvoice({
                            invoiceIds,
                            isLock: '0',
                          });
                        httpRequest
                          .post_reddingFailedBackWrite(errorList)
                          .then((res) => {
                            // logger.logError('红冲失败')
                          });
                      }
                    )
                    .finally(() => {
                      utils.loaded();
                      httpRequest.post_lockOvatInvoice({
                        invoiceIds,
                        isLock: '0',
                      });
                      $timeout(() => {
                        queryList();
                      }, 800);
                    });
                }
              });
          }
        }
      });
    };
    // 普票、卷票、电子票批量红冲 获取待开后开票
    $scope.openBatchRedInvoice = function (invoiceIds) {
      httpRequest.post_batchReddingInvoice(invoiceIds).then((res) => {
        if (res.data.success && res.data.value) {
          const invoice = res.data.value[0];
          if (
            invoiceOpenService.checkIsAgent(invoice) &&
            invoice.invType == '51'
          ) {
            openBatch(res.data.value, 1);
          } else {
            httpRequest
              .post_lockOvatInvoice({
                invoiceIds,
                isLock: '1',
              })
              .then(() => {
                const invoiceDTOs = res.data.value;
                const result = check(invoiceDTOs, false, true);
                if (!result) {
                  return;
                }
                if (invoiceOpenService.chechManageTypeDiff(invoiceDTOs))
                  return logger.logError(
                    '您选择的发票开票点不是同一个类型的，请重新选择'
                  );
                if (invoiceOpenService.checkIsA9(invoiceDTOs[0].ukeyId)) {
                  openBatch(invoiceDTOs, 2);
                } else {
                  invoiceOpenService.checkWithDiskInfo(invoiceDTOs).then(
                    () => {
                      // openBatch(invoiceDTOs)
                      checkdiffInvType(invoiceDTOs).then(() => {
                        openBatch(invoiceDTOs);
                      });
                    },
                    (error) => {
                      logger.logError(error);
                    }
                  );
                }
              })
              .finally(() => {
                httpRequest.post_lockOvatInvoice({
                  invoiceIds,
                  isLock: '0',
                });
              });
          }
        }
      });
    };

    function getChangeObj(changeInv, datalist) {
      // 返回要切换的obj
      let param = {};
      // 10位发票 2联5联公用
      let invAarry = datalist.filter(
        (item) =>
          item.invoiceType == '2' &&
          item.categoryCode.length == 10 &&
          item.categoryCode[8] == changeInv
      ); // 过滤出纸质票
      // 12位 2联
      if (changeInv == '2') {
        const invAarry2 = datalist.filter(
          (item) =>
            item.invoiceType == '2' &&
            item.categoryCode.length == 12 &&
            item.categoryCode[11] == '4'
        ); // 过滤出纸质票
        invAarry = invAarry.concat(invAarry2);
      }
      if (changeInv == '5') {
        const invAarry3 = datalist.filter(
          (item) =>
            item.invoiceType == '2' &&
            item.categoryCode.length == 12 &&
            item.categoryCode[11] == '5'
        ); // 过滤出纸质票
        invAarry = invAarry.concat(invAarry3);
      }
      // 12位 5联
      if (changeInv == '2' || changeInv == '5') {
        // 切换为2联或者5联开票
        if (invAarry.length > 0) {
          // 金税盘存在联次changeInv的发票卷
          let num = -1;
          for (let i = 0; i < invAarry.length; i++) {
            if (invAarry[i].collectCount > 0) {
              num = i;
              break;
            }
          }
          if (num >= 0) {
            param = {
              invType: '2',
              invCode: invAarry[num].categoryCode,
              startNumber: invAarry[num].startNumber,
            };
          }
        }
      }
      return param;
    }

    function checkdiffInvType(invoiceList) {
      return new Promise((resolve, reject) => {
        if (invoiceList[0].invType == '2') {
          //批量红冲只允许同票种，非普票直接结束
          httpRequest.get_getTaxDisk(invoiceList[0].ukeyId).then((res) => {
            const soap =
              (localStorage.soap && JSON.parse(localStorage.soap)) || {};
            if (res.data.value.differentInvoice === 1 && soap.status == 3) {
              // 普票存在不同联次发票
              // 切换票卷 然后开票
              $uibModal
                .open({
                  templateUrl: 'paperInvoiceNum2.html',
                  controller: [
                    '$scope',
                    '$uibModalInstance',
                    function ctrl(scope, uibModalInstance) {
                      scope.ivoiceNum = '2'; // 默认2联式发票
                      scope.cancel = function cancel() {
                        uibModalInstance.close();
                      };
                      scope.ok = function ok() {
                        uibModalInstance.close(scope.ivoiceNum);
                      };
                    },
                  ],
                  openedClass: 'mod-modal mod-modal-md',
                  backdrop: 'static',
                })
                .result.then(
                  (result) => {
                    if (result) {
                      utils.loading('正在红冲，请稍候');
                      invoiceOpenService
                        .getStockByUkey(
                          JSON.parse(localStorage.user_info).sysUkeyList,
                          invoiceList[0].ukeyId,
                          '2'
                        )
                        .then(
                          (obj) => {
                            if (obj.invoiceCode[8] != result) {
                              invoiceOpenService.queryInvoiceStock().then(
                                (res) => {
                                  // 金税盘所有库存
                                  let param = getChangeObj(result, res); // 获取下一张票
                                  if (JSON.stringify(param) !== '{}') {
                                    // 有票切换票卷并开票
                                    stockService
                                      .changeInvoiceUnionType(param)
                                      .then(() => {
                                        resolve();
                                      });
                                  } else {
                                    //
                                    // let inv5Aarry = res.filter(item => (item.invoiceType == "2" && item.categoryCode[8] == "5"))
                                    // let inv2Aarry = res.filter(item => (item.invoiceType == "2" && item.categoryCode[8] == "2"))
                                    const inv2Aarry10 = res.filter(
                                      (item) =>
                                        item.invoiceType == '2' &&
                                        item.categoryCode.length == 10 &&
                                        item.categoryCode[7] == '6' &&
                                        item.categoryCode[8] == '2'
                                    );
                                    const inv2Aarry12 = res.filter(
                                      (item) =>
                                        item.invoiceType == '2' &&
                                        item.categoryCode.length == 12 &&
                                        item.categoryCode[10] == '0' &&
                                        item.categoryCode[11] == '4'
                                    );
                                    const inv2Aarry = []
                                      .concat(inv2Aarry10)
                                      .concat(inv2Aarry12);

                                    const inv5Aarry10 = res.filter(
                                      (item) =>
                                        item.invoiceType == '2' &&
                                        item.categoryCode.length == 10 &&
                                        item.categoryCode[7] == '6' &&
                                        item.categoryCode[8] == '5'
                                    ); // 过滤出纸质票
                                    const inv5Aarry12 = res.filter(
                                      (item) =>
                                        item.invoiceType == '2' &&
                                        item.categoryCode.length == 12 &&
                                        item.categoryCode[10] == '0' &&
                                        item.categoryCode[11] == '5'
                                    ); // 过滤出纸质票
                                    const inv5Aarry = []
                                      .concat(inv5Aarry10)
                                      .concat(inv5Aarry12);

                                    if (
                                      result == '2' &&
                                      inv2Aarry.length == 0
                                    ) {
                                      utils.loaded();
                                      logger.logError('发票库存不足');
                                      reject();
                                    }
                                    if (
                                      result == '5' &&
                                      inv5Aarry.length == 0
                                    ) {
                                      // 5联票用完切换
                                      utils.loaded();
                                      sweetalert
                                        .confirm(
                                          '操作提醒',
                                          '当前开票点/金税盘不存在5联式的空白发票，是否继续开具2联式的发票？'
                                        )
                                        .then(() => {
                                          utils.loading(
                                            '正在批量红冲，请耐心等待'
                                          );
                                          param = getChangeObj('2', res); // 切换2联发票开票
                                          if (JSON.stringify(param) !== '{}') {
                                            stockService
                                              .changeInvoiceUnionType(param)
                                              .then(() => {
                                                resolve();
                                              });
                                          } else {
                                            logger.logError('发票库存不足');
                                            reject();
                                          }
                                        });
                                    }
                                  }
                                },
                                (err) => {
                                  utils.loaded();
                                  logger.logError(err);
                                  reject();
                                }
                              );
                            } else {
                              resolve();
                            }
                          },
                          (error) => {
                            logger.logError('发票库存查询失败');
                            reject();
                          }
                        );
                    }
                  },
                  () => {
                    reject();
                  }
                );
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
    // 普票、卷票、电子票批量红冲打印 获取待开后开票
    $scope.openBatchRedInvoicePrint = function (invoiceIds) {
      httpRequest.post_batchReddingInvoice(invoiceIds).then((res) => {
        if (res.data.success && res.data.value) {
          httpRequest
            .post_lockOvatInvoice({
              invoiceIds,
              isLock: '1',
            })
            .then(() => {
              const invoiceDTOs = res.data.value;
              const result = check(invoiceDTOs, true);
              if (!result) {
                return;
              }
              if (!invoiceOpenService.checkIsA9(invoiceDTOs[0].ukeyId)) {
                invoiceOpenService.checkWithDiskInfo(invoiceDTOs).then(
                  (diskInfo) => {
                    checkdiffInvType(invoiceDTOs).then(() => {
                      openPrintBatch(invoiceDTOs, diskInfo);
                    });
                  },
                  (error) => {
                    logger.logError(error);
                  }
                );
              }
              invoiceOpenService.checkIsA9(invoiceDTOs[0].ukeyId) &&
                openPrintBatch(invoiceDTOs, {});
            })
            .finally(() => {
              httpRequest.post_lockOvatInvoice({
                invoiceIds,
                isLock: '0',
              });
            });
        }
      });
    };
    // 获取选中id数组
    function getSelectedArr(invoiceDTOs) {
      const selectedArr = [];
      invoiceDTOs.forEach((invoice) => {
        selectedArr.push(invoice.waitId);
      });
      return selectedArr;
    }
    // 检验是否选中了相同种类发票
    function checkSelectedSameInvType(arr, oldid, newid) {
      const selectedArr = [];
      const o = arr;
      for (const m in o) {
        if (o[m].hasOwnProperty(oldid) && o[m][oldid] && o[m][newid]) {
          selectedArr.push(o[m][newid]);
        }
      }
      const newArr = Array.from(new Set(selectedArr));
      return newArr;
    }
    // 机动车批量发票开具
    function plPreIssueOpen(arr, dyflag, len, serial) {
      const actionMsg = !dyflag ? '开具' : '开具打印';
      const invoice = arr[serial];
      const msg = `请您耐心等待···正在${actionMsg}第${
        serial + 1
      }张发票；发票种类机动车发票`;
      const opening = window.layer.msg(msg, {
        time: 0,
        skin: 'layer-loading-self',
        icon: 16,
        shade: 0.5,
      });
      const dyPromise = dyflag
        ? invoiceOpenService.openPrint(invoice)
        : invoiceOpenService.open(invoice);
      dyPromise
        .catch((error) => {
          $scope.errorNum += 1;
          // httpRequest.post_writeOvatInvoiceFailReason({
          //     reason: error.retmsg,
          //     waitId: invoice.waitId,
          // })
        })
        .finally(() => {
          if (serial < len - 1) {
            serial += 1;
            plPreIssueOpen(arr, dyflag, len, serial);
          } else if (serial === len - 1) {
            window.layer.close(opening);
            logger.logMsg({
              title: '操作结果',
              icon: 1,
              message: `共计${len}张发票,成功${len - $scope.errorNum}张，失败${
                $scope.errorNum
              }张！`,
            });
          }
          queryList();
        });
    }
    // 普票、卷票、机动车 批量开票统一入口
    $scope.openOtherBatchRed = function (invoiceIds, isVehicle) {
      if (isVehicle) {
        // 机动车批量红冲
        httpRequest.post_batchReddingInvoice(invoiceIds).then((res) => {
          if (res.data.success && res.data.value) {
            httpRequest
              .post_lockOvatInvoice({
                invoiceIds,
                isLock: '1',
              })
              .then(() => {
                const invoiceDTOs = res.data.value;
                const waitIdsArrLen = invoiceDTOs.length;
                const result = check(invoiceDTOs, true, true);
                if (!result) {
                  return;
                }
                invoiceOpenService.checkWithDiskInfo(invoiceDTOs).then(
                  () => {
                    sweetalert
                      .confirm(
                        '操作提醒',
                        `当前执行批量开票的单据份数为${waitIdsArrLen}张，请确认`
                      )
                      .then(() => {
                        const serial = 0;
                        const submitWaitIds = getSelectedArr(invoiceDTOs);
                        httpRequest
                          .post_batchSubmitOvatInvoiceWait(submitWaitIds)
                          .then((res11) => {
                            $scope.errorNum = 0;
                            plPreIssueOpen(
                              invoiceDTOs,
                              false,
                              waitIdsArrLen,
                              serial
                            );
                          });
                      });
                  },
                  (error) => {
                    logger.logError(error);
                  }
                );
              })
              .finally(() => {
                httpRequest.post_lockOvatInvoice({
                  invoiceIds,
                  isLock: '0',
                });
              });
          }
        });
      } else {
        $scope.openBatchRedInvoice(invoiceIds);
      }
    };
    // 普票、卷票、机动车 批量开票打印统一入口
    $scope.openOtherBatchRedPrint = function (
      invoiceIds,
      isVehicle,
      invoiceList
    ) {
      if (invoiceOpenService.chechManageTypeDiff(invoiceList))
        return logger.logError(
          '您选择的发票开票点不是同一个类型的，请重新选择'
        );
      sweetalert
        .confirm(
          '操作提醒',
          '批量开票完成后将自动执行批量打印操作，若存在多个发票号段，易出现纸质票与需打印的发票电子信息不一致的情况，请检查好可供开具的空白发票号段与打印机上的空白纸质发票是否一致，谨慎操作！'
        )
        .then(() => {
          if (isVehicle) {
            // 机动车批量红冲
            console.log('机动车红冲');
            httpRequest.post_batchReddingInvoice(invoiceIds).then((res) => {
              if (res.data.success && res.data.value) {
                httpRequest
                  .post_lockOvatInvoice({
                    invoiceIds,
                    isLock: '1',
                  })
                  .then(() => {
                    const invoiceDTOs = res.data.value;
                    const waitIdsArrLen = invoiceDTOs.length;
                    const result = check(invoiceDTOs, true, true);
                    if (!result) {
                      return;
                    }
                    invoiceOpenService.checkWithDiskInfo(invoiceIds).then(
                      () => {
                        // 批量打印不能选不同种类的发票
                        const checkSameInvType = checkSelectedSameInvType(
                          $scope.resData,
                          'selected',
                          'invType'
                        );
                        if (checkSameInvType.length > 1) {
                          logger.logError('请选择同种类发票进行开票并打印');
                          return;
                        }
                        const tipsHtml = `<div>
                                    <h5 style="font-size: 16px; font-weight: 500; color: #333; margin-bottom: 20px;">您正在进行打印发票的操作，请确保您选择的发票是否与打印机上的纸质发票对应！</h3>
                                        <p>发票种类：机动车发票</p>
                                        <p>发票份数：${waitIdsArrLen}</p>
                                    </div>`;
                        // 确认弹窗
                        sweetalert.confirm('', tipsHtml).then(() => {
                          const serial = 0;
                          const waitIds = getSelectedArr(invoiceDTOs);
                          httpRequest
                            .post_batchSubmitOvatInvoiceWait(waitIds)
                            .then((res11) => {
                              $scope.errorNum = 0;
                              plPreIssueOpen(
                                invoiceDTOs,
                                true,
                                waitIdsArrLen,
                                serial
                              );
                            });
                        });
                      },
                      (error) => {
                        logger.logError(error);
                      }
                    );
                  })
                  .finally(() => {
                    httpRequest.post_lockOvatInvoice({
                      invoiceIds,
                      isLock: '0',
                    });
                  });
              }
            });
          } else {
            $scope.openBatchRedInvoicePrint(invoiceIds);
          }
        });
    };
    // 8.-------------------导出
    $scope.exportInvoic = function () {
      const getdata = $scope.exportParam;
      const idArr = [];
      // console.log($scope.exportParam ,$scope.selectedList)
      $scope.selectedList.forEach((item) => {
        idArr.push(item.invoiceId);
      });
      getdata.idList = idArr.join(',');
      // let dataStr = '?'
      // Object.keys(getdata).forEach((key) => {
      //     if (getdata[key] || getdata[key] === 0) {
      //         dataStr += `${key}=${encodeURI(getdata[key])}&`
      //     }
      // })
      // dataStr = `${dataStr}accessToken=${localStorage.getItem('id_token')}`
      let url = `${host.etcloudOvat}openedInvoice/exportEInvoiceToXLS`;
      if (getdata.isEleInv == '0') {
        url = `${host.etcloudOvat}openedInvoice/exportInvoiceToXLS`;
      }
      if (getdata.invType == 12) {
        url = `${host.etcloudOvat}openedInvoice/exportVInvoiceToXLS`;
      }
      url = `${url}?accessToken=${localStorage.getItem('id_token')}`;
      for (let i in $scope.param.orderMap) {
        getdata.sortField = i + ':' + $scope.param.orderMap[i];
      }
      console.log(getdata);
      utils.post_downLoad(getdata, url);
    };
    // 8.-------------------导出
    $scope.exportTXT = function () {
      sweetalert
        .confirm(
          '操作提醒',
          '将按照开票软件”单据管理“列表导出 "已开发票传出.txt”接口文件，设置的导出字段对此无效！'
        )
        .then(() => {
          const getdata = $scope.exportParam;
          const idArr = [];
          // console.log($scope.exportParam ,$scope.selectedList)
          $scope.selectedList.forEach((item) => {
            idArr.push(item.invoiceId);
          });
          getdata.idList = idArr.join(',');
          // let dataStr = '?'
          // Object.keys(getdata).forEach((key) => {
          //     if (getdata[key] || getdata[key] === 0) {
          //         dataStr += `${key}=${encodeURI(getdata[key])}&`
          //     }
          // })
          // dataStr = `${dataStr}accessToken=${localStorage.getItem('id_token')}`
          let url = `${
            host.etcloudOvat
          }openedInvoice/exportInvoiceToTxt?accessToken=${localStorage.getItem(
            'id_token'
          )}`;
          // url += dataStr
          console.log(url);
          for (let i in $scope.param.orderMap) {
            getdata.sortField = i + ':' + $scope.param.orderMap[i];
          }
          utils.post_downLoad(getdata, url);
        });
    };

    /** *************************批量功能************************ */
    // 7.------------------ 数据同步
    $scope.openSynInvoiceData = function openSynInvoiceData() {
      let ukeyList = JSON.parse(localStorage.user_info).sysUkeyList;
      if (!ukeyList.length) return logger.logError('未授权开票点！');

      // 弹窗
      const prams = {
        dictData: $scope.dictData,
      };
      if ($scope.param.param.invType == 12) prams.invType = 12;
      if ($scope.param.param.invType == 41) prams.invType = 41;
      if ($scope.active == 2) {
        prams.invType = ''
        prams.active = '2'
       }
      const modalInstance = $uibModal.open({
        template: synInvoicTemplate,
        controller: 'modalSynInvoicCtrl',
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-lg mod-modal-syninvoice',
        resolve: {
          items1() {
            return prams;
          },
        },
      });

      modalInstance.result.then(
        (data) => {
          data.totalRecNo = 0;
          data.pageIndex = 1;
          let fpzlArr = [];
          if (data.invType) {
            fpzlArr.push(data.invType);
          }else if ($scope.active == 2) {
            fpzlArr = ['51', '52']
          }  else {
            fpzlArr = ['0', '2'];
          }
          utils.loading('正在数据同步(已同步0张)，请耐心等待');
          console.log(data);
          if (data.manageType == '2') {
            const param = {
              invoiceCode: data.invoiceCode,
              invoiceNumberEnd: data.invoiceNumberEnd,
              invoiceNumberStart: data.invoiceNumberStart,
              ukeyId: data.ukeyId,
            };
            httpRequest
              .post_synInvoice(param)
              .then((res) => {
                const result = res.data.value;
                if (result.successCount) {
                  const inv = $filter('filter')($scope.dictData.inv_type, {
                    enumCode: result.invType,
                  })[0];
                  logger.logSuccess(
                    `同步完成!最终同步${inv.enumName}${result.successCount}张`
                  );
                } else {
                  logger.logError('同步失败');
                }
              })
              .finally(() => {
                utils.loaded();
                $timeout(() => {
                  queryList();
                }, 800);
              });
          } else {
            openedInvoiceService
              .synchronize(data, fpzlArr)
              .then(
                (totalRecNo) => {
                  logger.logSuccess(`同步完成!最终同步发票数量:${totalRecNo}`);
                },
                (err) => {
                  logger.logError(err);
                }
              )
              .finally(() => {
                utils.loaded();
                $timeout(() => {
                  queryList();
                }, 800);
              });
          }
        },
        () => {}
      );
    };
    // 查看关联销售单
    $scope.relatedBill = function (item) {
      if (item.billCount === 0) {
        return;
      }
      if (item.waitId === undefined) {
        return;
      }
      $state.go('outputManage.billManage.openedInvoice.relatedBill', {
        waitId: item.waitId,
      });
    };

    // 分页
    $scope.totalItems = 0; // 组件初始化设置总页数
    $scope.currentPage = 1; // 设置显示第一页
    $scope.maxSize = 10; // 每一叶显示记录数
    $scope.pageChanged = function () {
      // 点击页码发起查询
    //   sessionStorage.setItem(
    //     stroageStr,
    //     JSON.stringify({
    //       orderMap: $scope.param.orderMap,
    //       pageNum: $scope.param.pageNum,
    //       pageSize: $scope.param.pageSize,
    //       param: sessionStorage[stroageStr]
    //         ? JSON.parse(sessionStorage[stroageStr]).param
    //         : paramObj,
    //     })
    //   );
      queryList();
    };
    $scope.imageUrl = function (id, num) {
        let imageId = id ? id : '';
        let claimNumber = num ? num : '';
        let url = `${
          host.etcloudImage
        }Preview?id=${imageId}&claimNumber=${claimNumber}&sid=3018&accessToken=${localStorage.getItem(
          'id_token'
        )}`;
        window.open(url, '_blank');
      };
      $scope.uploadFiles = function uploadFiles(v) {
        $uibModal
            .open({
                template:  modalUploadList,
                controller: 'openedInvmodalUploadCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-detail',
                resolve: {
                    items1() {
                        return {
                            uploadType: v,
                        }
                    },
                },
            })
            .result.then(() => {
                queryList();
            })
    }
  }
}
openedInvoiceListCtrl.$inject = [
  '$rootScope',
  '$scope',
  '$uibModal',
  '$filter',
  'logger',
  'httpRequest',
  '$state',
  'operationService',
  'sweetalert',
  '$timeout',
  'openedInvoiceService',
  'invoiceOpenService',
  'exportSettingService',
  'initSortService',
  'getOvatAmtService',
  'Upload',
];
export default openedInvoiceListCtrl;



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/openedInvoiceListCtrl.js